import React, { useState, useEffect, useRef } from 'react';
import cssLearningUnit from './LearningUnit.module.scss';

import ToolBarTopUnit from '../Tool/ToolBarTopUnit/ToolBarTopUnit.js'
import ToolBarBottomUnit from '../Tool/ToolBarBottomUnit/ToolBarBottomUnit.js'

import OpenWebWindow from '../Tool/OpenWebWindow/OpenWebWindow'
import BCAppsWindows from '../Tool/BCAppsWindows/BCAppsWindows'

import Settings from '../Tool/Settings/Settings'
import Glossary from '../Tool/Glossary/Glossary'
import NoteList from '../Tool/NoteList/NoteList'
import Resource from '../Tool/Resource/Resource'

import LUAssign from '../Tool/LUAssign/LUAssign'
import NoteEdit from '../Tool/NoteEdit/NoteEdit'

import ViderPlayerWindow from '../Tool/ViderPlayerWindow/ViderPlayerWindow'
import HistoryWindow from './LUUtils/HistoryWindow/HistoryWindow'
import ImageEditorWindow from './LUUtils/ImageEditorWindow/ImageEditorWindow'
import ImageDisplayWindow from '../Tool/ImageDisplayWindow/ImageDisplayWindow'
import AudioRecordingWindow from './LUUtils/AudioRecordingWindow/AudioRecordingWindow'
import StrokeWindow from './LUUtils/StrokeWindow/StrokeWindow'
import LearningUnitToolTip from '../Tool/LearningUnitToolTip/LearningUnitToolTip'

import LessonGoals from '../LearningUnit/Units/LessonGoals/LessonGoals.js'
import LessonAnimation from '../LearningUnit/Units/LessonAnimation/LessonAnimation.js'
import LessonIllustration from '../LearningUnit/Units/LessonIllustration/LessonIllustration.js'
import LessonLessonText from '../LearningUnit/Units/LessonLessonText/LessonLessonText.js'
import LanguageNotesVocabulary from '../LearningUnit/Units/LanguageNotesVocabulary/LanguageNotesVocabulary.js'
import LanguageNotesLanguagePoints from '../LearningUnit/Units/LanguageNotesLanguagePoints/LanguageNotesLanguagePoints.js'
import LanguageNotesLanguageTips from '../LearningUnit/Units/LanguageNotesLanguageTips/LanguageNotesLanguageTips.js'
import CulturePointsDiscoveringChina from '../LearningUnit/Units/CulturePointsDiscoveringChina/CulturePointsDiscoveringChina.js'
import CulturePointsChineseIdiom from '../LearningUnit/Units/CulturePointsChineseIdiom/CulturePointsChineseIdiom.js'
import PracticePinyinPronunciation from '../LearningUnit/Units/PracticePinyinPronunciation/PracticePinyinPronunciation.js'
import PracticePinyinIdentification from '../LearningUnit/Units/PracticePinyinIdentification/PracticePinyinIdentification.js'
import PracticePinyinDictation from '../LearningUnit/Units/PracticePinyinDictation/PracticePinyinDictation.js'
import PracticeCharacters from '../LearningUnit/Units/PracticeCharacters/PracticeCharacters.js'
import PracticeListening from '../LearningUnit/Units/PracticeListening/PracticeListening.js'
import PracticeFluency from '../LearningUnit/Units/PracticeFluency/PracticeFluency.js'
import PracticeSpeaking from '../LearningUnit/Units/PracticeSpeaking/PracticeSpeaking.js'
import PracticeReadingComprehension from '../LearningUnit/Units/PracticeReadingComprehension/PracticeReadingComprehension.js'
import PracticeReadingChallenge from '../LearningUnit/Units/PracticeReadingChallenge/PracticeReadingChallenge.js'
import PracticeWritingGrammarExercises from '../LearningUnit/Units/PracticeWritingGrammarExercises/PracticeWritingGrammarExercises.js'
import PracticeWritingComposition from '../LearningUnit/Units/PracticeWritingComposition/PracticeWritingComposition.js'
import PracticeActivity from '../LearningUnit/Units/PracticeActivity/PracticeActivity.js'
import ReviewListening from '../LearningUnit/Units/ReviewListening/ReviewListening.js'
import ReviewReading from '../LearningUnit/Units/ReviewReading/ReviewReading.js'
import ReviewWritingGrammarExercises from '../LearningUnit/Units/ReviewWritingGrammarExercises/ReviewWritingGrammarExercises.js'
import ReviewWritingComposition from '../LearningUnit/Units/ReviewWritingComposition/ReviewWritingComposition.js'
import ReviewSpeaking from '../LearningUnit/Units/ReviewSpeaking/ReviewSpeaking.js'
import CanDoStatements from '../LearningUnit/Units/CanDoStatements/CanDoStatements.js'

// import DownloadAnotherAppWindow from '../Tool/DownloadAnotherAppWindow/DownloadAnotherAppWindow'

import Slide from '@material-ui/core/Slide'

import {LoadingMask, AlertWindow, CredentialMultiInWindow, ClientGatewayInPackage, TimeZoneLibs, GlobalLibs, NetworkLibs, LocalStorageLibs, RoutePathLibs, PackageVariablesLibs} from 'bc-react-package'

export const LUCacheContext = React.createContext({})

// #region Constant
const COMP_NAME = "LearningUnit"
const MULTI_PAGES_LU_LIST = [
    "03", // 插圖
    "05", // 生詞
    "06", // 語法點
    "07", // 語言說明 語言知識
    "08", // 文化點 中國文化
    "09", // 文化點 中國成語
    "14", // 練習 說一說
    "16", // 讀一讀
    "18", // 練習 寫一寫
    "19", // 練習 小組活動
    "22", // 回家作業 寫一寫
    "23"  // 回家作業 說一說
]
// #endregion Constant

// #region Enumeration
export const GoToLUSinceActionEnum = {
    Default: 1, // 直接點擊Menu開啟
    GoPrev: 2, // 從Previous按鈕來的
    GoNext: 3 // 從Next按鈕來的
}

const ChangeLUFromEnum = {
    "None": 0,
    "NextOnTap": 1,
    "PreviousOnTap": 2,
    "SectionOnTap": 3,
    "SubSectionOnTap": 4
}
// #endregion Enumeration

// #region State Member Variables
let mstrStateLUCatSeqNo = ""
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false
let mblnIfNeed2GoToApplicationHomePage = null

let mobjSectionLULookUpTable = {
    BookSeqNo: "",
    LookUpTable: []
}
let mobjCurrentSectionIndexs = {
    SectionIndex: -1,
    SubSectionIndex: -1,
    SubSubSectionIndex: -1
}
let mobjMultiPagedLUCalledInfo = {
    NextOnTapHandlerRef: null, // 當有Multiple Page時 用來觸發LU內部的Next事件
    PrevOnTapHandlerRef: null, // 當有Multiple Page時 用來觸發LU內部的Previous事件
    CanBePrev: false, // LU內部判斷 是否有上一頁
    CanBeNext: false // LU內部判斷 是否有下一頁
}
let mobjCallerInfoForHistoryWindow =
{
    CallbackRef: null, // 觸發LU內的Function
    LessonID: "", // 目前的LessonID
    AssigementHistoryList: [], // 歷史清單
    AssignmentTempAns: null // 答題只答部分 尚未完成考卷
}
let mobjCallerInfoForImageEditorWindow = {
    CallbackRef: null, // 觸發LU內的Function
    Arguments: null // 所有要傳遞的變數 都放次 e.g. Arguments: { key01: val01, key02: val02}
}
let mobjCallerInfoForStrokeWindow = {
    CallbackRef: null, // 觸發LU內的Function
    Arguments: null // 所有要傳遞的變數 都放次 e.g. Arguments: { key01: val01, key02: val02}
}
let mobjCallerInfoForAudioRecorderWindow = {
    CallbackRef: null, // 觸發LU內的Function
    Arguments: null // 所有要傳遞的變數 都放次 e.g. Arguments: { key01: val01, key02: val02}
}
let mobjCallerInfoForImageDisplayWindow = {
    CallbackRef: null, // 觸發LU內的Function
    Arguments: null // 所有要傳遞的變數 都放次 e.g. Arguments: { key01: val01, key02: val02}
}
let mobjCallerInfoForVideoPlayerWindow = {
    CallbackRef: null, // 觸發LU內的Function
    Arguments: null // 所有要傳遞的變數 都放次 e.g. Arguments: { key01: val01, key02: val02}
}
let mobjCallerInfoForGlossaryWindow = {
    CallbackRef: null, // 觸發LU內的Function
    Arguments: null // 所有要傳遞的變數 都放次 e.g. Arguments: { key01: val01, key02: val02}
}

let mintTotalLUs = 0
let mintGoToLUSinceAction = GoToLUSinceActionEnum.Default
// Swipe
let mblnIsSwipeDisable = false
let mintTouchStartX = 0
let mintTouchStartY = 0
let mdatTouchStartTime = null // 用於偵測左右滑動換頁
let mblnTouchBegan = false // 用於偵測左右滑動換頁
let mstrBookSeqNo = ""
let mintLessonIndex = 0
let marrLessonTitle = []
let mobjShowComponentParam = null
let mobjAuthorizedSubscription = null
let mobjLUCacheContext = {
    "AssigementHistoryList": {},
    "AssignmentTempAnsList": {},
    "AccountStorage": {}
}
let mblnIsTestSheetContextDirty = false // 告訴Learning Unit 為了在使用者直接切換LU時 可以偵測到目前有Dirty
let mintChangeLUFrom = ChangeLUFromEnum.None
let mintTempSectionIndexSelected = -1 // 在Menu上 點擊的SectionIndex
let mintTempSubSectionIndexSelected = -1 // 在Menu上 點擊的SubSectionIndex
let mfuncLanguageChangeHandler = null // 當設定Language的簡體/繁體改變後 用此Function通知LU
let mobjCallParam = null
let mblnChangePageByTouchEvent = true // 預設啟用左右滑動可換頁 但有些LU的部分區塊 App用手指左右滑動時要停用換頁 e.g. Character的 寫字區塊, 左右的scroll的區塊
// #endregion Member Variables

function LearningUnit(props)
{
    console.log(COMP_NAME + ".Begin")
    console.log("props.location.state: ", props.location.state)
    console.log("window.gSession.App.CurrentLesson: ", window.gSession.App.CurrentLesson)

    // #region Init State   
    const [lUSeqNo, setLUSeqNo] = useState("01") // default Goals

    const [toolMenu, setToolMenu] = useState(false)
    const [toolMenuAnimation, setToolMenuAnimation] = useState(false)
    const [lessonListAnimation, setLessonListAnimation] = useState(false)

    const [isShowOpenWebWindow, setIsShowOpenWebWindow] = useState(false)
    const [isShowBCAppsWindows, setIsShowBCAppsWindows] = useState(false)

    const [isShowSettings, setIsShowSettings] = useState(false)
    const [isShowGlossary, setIsShowGlossary] = useState(false)
    const [isShowNoteList, setIsShowNoteList] = useState(false)
    const [isShowResource, setIsShowResource] = useState(false)

    const [isShowLUAssign, setIsShowLUAssign] = useState(false)
    const [isShowNoteEdit, setIsShowNoteEdit] = useState(false)

    const [showHistoryWindow, setShowHistoryWindow] = useState(false) // 顯示/隱藏 HistoryWindow
    const [showImageEditorWindow, setShowImageEditorWindow] = useState(false) // 顯示/隱藏 圖片編輯視窗
    const [showAudioRecorderWindow, setShowAudioRecorderWindow] = useState(false)  // 顯示/隱藏 錄音視窗
    const [showImageDisplayWindow, setShowImageDisplayWindow] = useState(false)  // 顯示/隱藏 錄音視窗
    const [showStrokeWindow, setShowStrokeWindow] = useState(false)  // 顯示/隱藏 Stroke視窗
    const [showViderPlayerWindow, setShowViderPlayerWindow] = useState(false) // 隱藏/顯示 Video Player
    const [isShowLearningUnitToolTip, setIsShowLearningUnitToolTip] = useState(false)   // 隱藏/顯示 LearningUnit Tool Tip
    // const [showDownloadAnotherAppWindow, setShowDownloadAnotherAppWindow] = useState(false) // 顯示/隱藏 下載iOS App DCPAssessment

    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    const [showCredentialMultiIn, setShowCredentialMultiIn] = useState(false)
    const [credentialMultiInArguments, setCredentialMultiInArguments] = useState(null)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefSetLastAccessLU = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefSetLastAccessLU.current = SetLastAccessLU
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        mblnIfNeed2GoToApplicationHomePage = RoutePathLibs.CheckIfNeed2GoToApplicationHomePage(props.history)
        // console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)

        mstrBookSeqNo = window.gSession.App.BookSeqNo.toString().PadLeft(2)
        marrLessonTitle = GetLessonTitle(mstrBookSeqNo)

        // 找 LessonIndex
        mintLessonIndex = 0
        mintLessonIndex = window.gSession.App.BookDef[mstrBookSeqNo].Lesson.findIndex(Lesson => Lesson.ID === props.location.state.LessonID)
        console.log(COMP_NAME + ".First Launch mstrBookSeqNo: ", mstrBookSeqNo)
        console.log(COMP_NAME + ".First Launch marrLessonTitle: ", marrLessonTitle)
        console.log(COMP_NAME + ".First Launch mintLessonIndex: ", mintLessonIndex)

        if (mobjSectionLULookUpTable.BookSeqNo !== "strBookSeqNo")
        {
            console.log("need to generate Section LU LookUpTable with BookSeqNo: ", mstrBookSeqNo)
            GenerateSectionLULookUpTable(mstrBookSeqNo)
        }
        console.log("mobjSectionLULookUpTable: ", mobjSectionLULookUpTable)
        mintTotalLUs = mobjSectionLULookUpTable.LookUpTable.length
        console.log("mintTotalLUs: ", mintTotalLUs)

        let strLUCatSeqNo = props.location.state.LUSeqNo.toString().PadLeft(2)

        // mobjCurrentSectionIndexs = JSON.parse(JSON.stringify(mobjSectionLULookUpTable.LookUpTable.find(Item => Item.LUCatSeqNo === strLUCatSeqNo).SectionIndexs))
        let objLookUpItem = mobjSectionLULookUpTable.LookUpTable.find(Item => Item.LUCatSeqNo === strLUCatSeqNo)
        if (
            (typeof (objLookUpItem) !== "undefined") &&
            (objLookUpItem !== null)
            )
        {
            mobjCurrentSectionIndexs = JSON.parse(JSON.stringify(objLookUpItem)).SectionIndexs
        }

        console.log("mobjCurrentSectionIndexs: ", mobjCurrentSectionIndexs)

        mblnInitialized = true
    }
    // #endregion First Launch

    // #region useEffect
    // Update toolMenu
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect toolMenu")
        if (toolMenu)
        {
            setToolMenuAnimation(true)
            setLessonListAnimation(true)
        }
    }, [toolMenu])

    // Update lUSeqNo
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect lUSeqNo")
        mstrStateLUCatSeqNo = lUSeqNo
        mrefSetLastAccessLU.current(lUSeqNo)
    }, [lUSeqNo])

    useEffect(() => {
        let strLUCatSeqNo = props.location.state.LUSeqNo.toString().PadLeft(2)
        mintGoToLUSinceAction = GoToLUSinceActionEnum.Default
        GoToLU(strLUCatSeqNo)
    }, [props.location.state.LUSeqNo])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        if (!mblnIfNeed2GoToApplicationHomePage)
        {
            let objWindowRefs = {
                OpenLoadingMask: OpenLoadingMask,
                CloseLoadingMask: CloseLoadingMask,
                ShowAlert: ShowAlert,
                ShowCredentialMultiInWindow: ShowCredentialMultiInWindow
            }
            // AAALibs.RegisterCallerWindownFuncRefs(objWindowRefs)
            GlobalLibs.RegisterCallerWindownFuncRefs(objWindowRefs)

            mrefPaintedMe.current()
        }

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            if (!mblnIfNeed2GoToApplicationHomePage)
            {
                // AAALibs.UnRegisterCallerWindownFuncRefs()
                GlobalLibs.UnRegisterCallerWindownFuncRefs()
            }

            mobjLUCacheContext = {
                "AssigementHistoryList": {},
                "AssignmentTempAnsList": {},
                "AccountStorage": {}
            }

            mblnInitialized = false
            mobjShowComponentParam = null
            mobjAuthorizedSubscription = null
            mintChangeLUFrom = ChangeLUFromEnum.None

            setToolMenu(false)
            setToolMenuAnimation(false)
            setLessonListAnimation(false)

            setIsShowOpenWebWindow(false)
            setIsShowBCAppsWindows(false)

            setIsShowSettings(false)
            setIsShowGlossary(false)
            setIsShowNoteList(false)
            setIsShowResource(false)

            setLUSeqNo("01")

            mfuncLanguageChangeHandler = null
        }
    }, [props.location.pathname])
    // #endregion useEffect

    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2022/01/13 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        // Session 跳1次 總共跳5次（登出後重新登入和auto login）
        if (!window.gSession.Acc.ShowTip)
        {
            if (window.gSession.Acc.TipCount < window.gConst.TIP_MAX_COUNT)
            {
                setIsShowLearningUnitToolTip(true)

                window.gSession.Acc.TipCount++

                LocalStorageLibs.SetAccLSElement("TipCount", window.gSession.Acc.TipCount)

                window.gSession.Acc.ShowTip = true

                console.log(COMP_NAME + ".PaintedMe TipCount:", window.gSession.Acc.TipCount)
            } // end of if (window.gSession.Acc.TipCount < window.gConst.TIP_MAX_COUNT)
        } // end of if (!window.gSession.Acc.ShowTip)
    } // end of PaintedMe
    // #end region Painted Me

    // function GetAssignmentAssignAnswer(LUCatSeqNo)
    // {
    //     console.log(COMP_NAME + ".GetAssignmentAssignAnswer")

    //     let objRetryFuncRef = GetAssignmentAssignAnswer
    //     if (!window.navigator.onLine)
    //     {
    //         GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef);
    //     }
    //     else
    //     {
    //         let objCallbackFuncRef = GetAssignmentAssignAnswerCallback;
    //         // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

    //         // Open Loading mask with message
    //         OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAssignmentAssignAnswer);

    //         // Func: "GetNewAssignmentAssignAnswer"
    //         // AssignID: -1
    //         // Assignee: 459
    //         // BookCategoryID: "03"
    //         // LUCatSeqNo: 11
    //         // LessonID: "03001"

    //         let objCallData = {
    //             "Func": "GetNewAssignmentAssignAnswer",
    //             "Assignee": window.gSession.Acc.ID,
    //             "BookCategoryID": window.Globals.PadLeft(window.gSession.App.BookCatID.toString(), 2),
    //             "LessonID": props.location.state.LessonID,
    //             "LUCatSeqNo": parseInt(LUCatSeqNo),
    //             "AssignID": -1
    //         };

    //         NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
    //         .then(Response => {
    //             objCallbackFuncRef(Response)
    //         }
    //     )

    //     }
    // }

    // /*===========================================
    // summary: 取得 使用者 資料 Callback
    //   param: (Json Object) Return : 後端回傳的資料Json物件
    //          (int) InstructionInfo : 執行的第幾個後端要求事件

    // retruns: 
    // remarks: 001 Tim 2020/12/08 Create
    // ===========================================*/
    // function GetAssignmentAssignAnswerCallback (Return, InstructionInfo)
    // {
    //     console.log(COMP_NAME + ".GetAssignmentAssignAnswerCallback: ", Return)
    //     // Close Loading mask        
    //     CloseLoadingMask()

    //     // you need to customize these
    //     let intDefaultErrNo = window.gAppUI.ERR_GetAssignmentAssignAnswer_No;
    //     let strErrorTitle = window.gAppUI.ERR_GetAssignmentAssignAnswer_Title;
    //     let strErrMsg = window.gAppUI.ERR_GetAssignmentAssignAnswer_Msg;
    //    

    //     if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
    //     {
    //         switch (Return.CalledErrNo)
    //         {
    //             // case customized error case:
    //             //     break;
    //             default:
    //                 // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute);
    //                 NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
    //                 break;
    //         }

    //         console.log("GetAssignmentAssignAnswerCallback: ErrNo: ", Return.ErrNo);
    //         console.log("GetAssignmentAssignAnswerCallback: CalledErrNo: ", Return.CalledErrNo);
    //     }
    //     else
    //     {
    //         console.log("GetAssignmentAssignAnswerCallback Return.Data", Return.Data);

    //         marrNewAssignmentHistory = Return.Data.NewAssignList

    //         setLUSeqNo(Return.Data.LUCatSeqNo)
    //         // GetAssignmentAssignAnswerAfterProcess(Return.Data, false)
    //     }
    // }

    function GetLUIndexInLookUpTable(LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GetLUIndexInLookUpTable: ", LUCatSeqNo)

        let intLUIndexInLookUpTable = -1
        mobjSectionLULookUpTable.LookUpTable.find(function (Item, Index)
        {
            let blnFound = false

            if (Item.LUCatSeqNo === LUCatSeqNo)
            {
                intLUIndexInLookUpTable = Index
                blnFound = true
            }

            return blnFound
        })
        console.log("intLUIndexInLookUpTable: ", intLUIndexInLookUpTable)

        return intLUIndexInLookUpTable
    }

    function GoToLU(LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GoToLU: ", LUCatSeqNo)

        mblnIsTestSheetContextDirty = false
        mobjMultiPagedLUCalledInfo = {}
        setLUSeqNo(LUCatSeqNo)
    }

    function GoToNextLU()
    {
        console.log(COMP_NAME + ".GoToNextLU")
        console.log("current LU: ", lUSeqNo)

        let intCurrentLUIndexInLookUpTable = GetLUIndexInLookUpTable(lUSeqNo)
        console.log("intCurrentLUIndex: ", intCurrentLUIndexInLookUpTable)
        let objNextLUSectionItem = mobjSectionLULookUpTable.LookUpTable[intCurrentLUIndexInLookUpTable + 1]
        console.log("objNextLUSectionItem: ", objNextLUSectionItem)
        mobjCurrentSectionIndexs = JSON.parse(JSON.stringify(objNextLUSectionItem.SectionIndexs))
        console.log("mobjCurrentSectionIndexs: ", mobjCurrentSectionIndexs)

        mintGoToLUSinceAction = GoToLUSinceActionEnum.GoNext
        GoToLU(objNextLUSectionItem.LUCatSeqNo)
    }

    function GoToPrevLU()
    {
        console.log(COMP_NAME + ".GoToPrevLU")
        console.log("current LU: ", lUSeqNo)

        let intCurrentLUIndexInLookUpTable = GetLUIndexInLookUpTable(lUSeqNo)
        console.log("intCurrentLUIndex: ", intCurrentLUIndexInLookUpTable)
        let objPrevLUSectionItem = mobjSectionLULookUpTable.LookUpTable[intCurrentLUIndexInLookUpTable - 1]
        console.log("objPrevLUSectionItem: ", objPrevLUSectionItem)
        mobjCurrentSectionIndexs = JSON.parse(JSON.stringify(objPrevLUSectionItem.SectionIndexs))
        console.log("mobjCurrentSectionIndexs: ", mobjCurrentSectionIndexs)

        mintGoToLUSinceAction = GoToLUSinceActionEnum.GoPrev
        GoToLU(objPrevLUSectionItem.LUCatSeqNo)
    }

    function NextOnTapHandler()
    {
        console.log(COMP_NAME + ".NextOnTapHandler")

        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        ProcessNext()
    }

    function PreviousOnTapHandler()
    {
        console.log(COMP_NAME + ".PreviousOnTapHandler");

        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        ProcessPrevious()
    }

    function GenerateSectionLULookUpTable(BookSeqNo)
    {
        console.log(COMP_NAME + ".GenerateSectionLULookUpTable", BookSeqNo)

        mobjSectionLULookUpTable.BookSeqNo = BookSeqNo
        mobjSectionLULookUpTable.LookUpTable = []

        let objLookUpTableItem = {
            LUCatSeqNo: "",
            SectionIndexs: {
                SectionIndex: -1,
                SubSectionIndex: -1,
                SubSubSectionIndex: -1
            }
        }
        let arrBookSectionDef = window.gSession.App.BookDef[BookSeqNo].Section

        arrBookSectionDef.forEach((Section, Index) => {
            console.log("Section: ", Section, Index)

            // let strSectionSeqNo = Section.SectionSeqNo
            let intSectionIndex = Index
            let arrSubSectionDef = Section.SubSection

            arrSubSectionDef.forEach((SubSection, Index) => {
                console.log("SubSection: ", SubSection, Index)

                // let strSubSectionSeqNo = SubSection.SubSectionSeqNo
                let intSubSectionIndex = Index
                let strLUCatSeqNo = SubSection.LUCatSeqNo
                if (typeof (strLUCatSeqNo) !== 'undefined')
                {
                    console.log("LU in Subsection: ", strLUCatSeqNo)
                    objLookUpTableItem = {
                        LUCatSeqNo: strLUCatSeqNo.PadLeft(2),
                        SectionIndexs: {
                            // SectionSeqNo: strSectionSeqNo,
                            // SubSectionSeqNo: strSubSectionSeqNo //,
                            // SubSubSectionSeqNo: ""
                            SectionIndex: intSectionIndex,
                            SubSectionIndex: intSubSectionIndex,
                            SubSubSectionIndex: -1
                        }
                    }

                    mobjSectionLULookUpTable.LookUpTable.push(objLookUpTableItem)

                }
                else
                {
                    console.log("LU not in Subsection, need to dig in SubSubSection")

                    let arrSubSubSectionDef = SubSection.SubSubSection
                    arrSubSubSectionDef.forEach((SubSubSection, Index) => {
                        console.log("SubSubSection: ", SubSubSection, Index)

                        // let strSubSubSectionSeqNo = SubSubSection.SubSubSectionSeqNo
                        let intSubSubSectionIndex = Index
                        let strLUCatSeqNo = SubSubSection.LUCatSeqNo
                        console.log("LU in SubSubsection: ", strLUCatSeqNo)
                        objLookUpTableItem = {
                            LUCatSeqNo: strLUCatSeqNo.PadLeft(2),
                            SectionIndexs: {
                                // SectionSeqNo: strSectionSeqNo,
                                // SubSectionSeqNo: strSubSectionSeqNo,
                                // SubSubSectionSeqNo: strSubSubSectionSeqNo
                                SectionIndex: intSectionIndex,
                                SubSectionIndex: intSubSectionIndex,
                                SubSubSectionIndex: intSubSubSectionIndex
                            }
                        }

                        mobjSectionLULookUpTable.LookUpTable.push(objLookUpTableItem)
                    })
                }
            })
        })
    }

    function ChangeLUViaSenctionIndex(SectionIndexsObject)
    {
        console.log(COMP_NAME + ".ChangeLUViaSenctionIndex: ", SectionIndexsObject)

        console.log("mobjSectionLULookUpTable.LookUpTable: ", mobjSectionLULookUpTable.LookUpTable)
        // let strLUCatSeqNo = mobjSectionLULookUpTable.LookUpTable.find(function (Item, Index)
        let objLookUpItem = mobjSectionLULookUpTable.LookUpTable.find(function (Item, Index)
        {
            console.log("Item, Index: ", Item, Index)

            let blnFound = false
            if (
                (Item.SectionIndexs.SectionIndex === SectionIndexsObject.SectionIndex) &&
                (Item.SectionIndexs.SubSectionIndex === SectionIndexsObject.SubSectionIndex)
                )
            {
                if (Item.SectionIndexs.SubSubSectionIndex === -1)
                {
                    console.log("LU found in SubSection")
                    blnFound = true
                }
                else
                {
                    if (Item.SectionIndexs.SubSubSectionIndex === SectionIndexsObject.SubSubSectionIndex)
                    {
                        console.log("LU found in SubSubSection")
                        blnFound = true
                    }
                }
            }

            return blnFound
            // }).LUCatSeqNo
        })

        let strLUCatSeqNo = ""
        if (
            (typeof (objLookUpItem) !== "undefined") &&
            (objLookUpItem !== null)
            )
        {
            strLUCatSeqNo = objLookUpItem.LUCatSeqNo
        }

        // 利用 state: LUCatSeqNo 的改變，引發 re-render, 來改變 LU
        mintGoToLUSinceAction = GoToLUSinceActionEnum.Default
        GoToLU(strLUCatSeqNo)
    }
    // #region OnTapHandler
    // summary: 點選 Section選單元件
    function SectionOnTapHandler(SectionIndex)
    {
        console.log(COMP_NAME + ".SectionOnTapHandler: ", SectionIndex)
        mintTempSectionIndexSelected = SectionIndex

        if (mblnIsTestSheetContextDirty)
        {
            // 有未Save或Submit的資料
            mintChangeLUFrom = ChangeLUFromEnum.SectionOnTap
            AlertTestSheetContextDirty()
        }
        else
        {
            mobjCurrentSectionIndexs = {
                SectionIndex: SectionIndex,
                SubSectionIndex: 0,
                SubSubSectionIndex: 0 // ?
            }
            ChangeLUFromSectionOnTap()
        }
    }

    // summary: 點選 SubSection選單元件
    function SubSectionOnTapHandler(SubSectionIndex)
    {
        console.log(COMP_NAME + ".SubSectionOnTapHandler: ", SubSectionIndex)
        mintTempSubSectionIndexSelected = SubSectionIndex

        if (mblnIsTestSheetContextDirty)
        {
            // 有未Save或Submit的資料
            mintChangeLUFrom = ChangeLUFromEnum.SubSectionOnTap
            AlertTestSheetContextDirty()
        }
        else
        {
            // SectionIndex 不改，只改 SubSectionIndex 以下
            mobjCurrentSectionIndexs.SubSectionIndex = SubSectionIndex
            mobjCurrentSectionIndexs.SubSubSectionIndex = 0
            ChangeLUFromSubSectionOnTap()
        }
    }

    function TestSheetContextDirtyAlertCallBack(BtnObject)
    {
        console.log(COMP_NAME + ".TestSheetContextDirtyAlertCallBack: ", BtnObject);
        if (BtnObject.index === 0)
        {
            // Still Continue
            console.log("Still Continue")

            ChangeLU()
        }
        else if (BtnObject.index === 1)
        {
            // Do nothing
            console.log("Finish My Exercise")
        }
    } // end of WebProductUnitAfterProcessAlertCallBack

    function AlertTestSheetContextDirty()
    {
        console.log(COMP_NAME + ".AlertTestSheetContextDirty")

        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.MSG_AnswerSaveCheck,
            ShowCloseButton: false,
            CallbackRef: TestSheetContextDirtyAlertCallBack,
            Buttons: [
                {
                    Text: window.gAppUI.BTN_StillContinue,
                    AutoFocus: false
                },
                {
                    Text: window.gAppUI.BTN_FinishMyExercise,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    }

    /*===========================================
    summary: 點選 Tool按鈕 
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function ToolOnTapHandler()
    {
        console.log(COMP_NAME + ".ToolOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setToolMenu(true)

        // let objMe = this
        // this.setState({
        //     ToolMenu: true
        // }, () => {
        //     objMe.setState({
        //         ToolMenuAnimation: true,
        //         LessonListAnimation: true
        //     });
        // })
    } // end of ToolOnTapHandler

    /*===========================================
    summary: 點選 Mask
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function MaskOnTapHandler()
    {
        console.log(COMP_NAME + ".MaskOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setToolMenuAnimation(false)
        setLessonListAnimation(false)
    } // end of MaskOnTapHandler

    /*===========================================
    summary: 點選 Lesson
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function LessonItemOnTapHandler(evnet, LessonID, Expired)
    {
        console.log(COMP_NAME + ".LessonItemOnTapHandler")

        evnet.preventDefault()
        evnet.stopPropagation()

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log(COMP_NAME + ".LessonItemOnTapHandler: LessonID: ", LessonID)
        console.log(COMP_NAME + ".LessonItemOnTapHandler: CurrentLesson.ID: ", window.gSession.App.CurrentLesson.ID)
        console.log(COMP_NAME + ".LessonItemOnTapHandler: Expired: ", Expired)

        if (!Expired)
        {
            // 有授權
            if (window.gSession.App.CurrentLesson.ID !== LessonID)
            {
                // 轉跳去 指定的 Lesson
                GotoLearningUnit(window.gSession.App.BookSeqNo, LessonID, window.gDCPLUEnum.LessonGoals)
            }
            else
            {
                setToolMenuAnimation(false)
                setLessonListAnimation(false)
            }
        }
        else
        {
            // 沒授權
            NoAuthorizedProcess(LessonID, window.gDCPLUEnum.LessonGoals)
        }
    } // end of LessonItemOnTapHandler
    // #endregion OnTapHandler

    // #region Other Handler
    // #endregion Other Handler

    // #region LoadingMask and Alert
    function OpenLoadingMask(LoadingMsg)
    {
        console.log("OpenLoadingMask: ", LoadingMsg)
        // 開啟 Loading Mask
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    }

    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask: ")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    }

    function ShowAlert(AlertObject)
    {
        console.log(COMP_NAME + ".ShowAlert")
        setAlertObject(AlertObject)
        setShowAlert(true)
    }

    function HideAlert()
    {
        console.log(COMP_NAME + ".HideAlert")
        setAlertObject(null)
        setShowAlert(false)
    }

    /*===========================================
    summary: 開啟 多重登入 阻擋視窗
    remarks: 000 Tim 2022/11/02 Create
    ===========================================*/
    function ShowCredentialMultiInWindow(Title, Message)
    {
        let objCredentialMultiInArguments = {
            "Title": Title,
            "Message": Message
        }
        setCredentialMultiInArguments(objCredentialMultiInArguments)
        setShowCredentialMultiIn(true)
    } // end of ShowCredentialMultiInWindow
    // #endregion LoadingMask and Alert  

    // #region Component Callback

    // remarks: 001 Tim 2023/09/07 開啟DCPAssessmentUrl App
    //                             不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
    // function DownloadAnotherAppWindowCallback(CallbackObj)
    // {
    //     console.log(COMP_NAME + ".DownloadAnotherAppWindowCallback CallbackObj: ", CallbackObj)

    //     if (CallbackObj.Action === "CloseDownloadAnotherAppWindow")
    //     {
    //         setShowDownloadAnotherAppWindow(false)
    //     }
    // }

    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback: ", CallbackObj)

        if (CallbackObj.Action === "OpenLoadingMask")
        {
            OpenLoadingMask(CallbackObj.Message)
        }
        else if (CallbackObj.Action === "CloseLoadingMask")
        {
            CloseLoadingMask()
        }
        else if (CallbackObj.Action === "ShowAlertWindow")
        {
            ShowAlert(CallbackObj.AlertObject)
        }
        else if (CallbackObj.Action === "WillUnmount")
        {
            setToolMenu(false)
        }
        else if (CallbackObj.Action === "InitCalledInfoInMultiPagedLU")
        {
            // 將LU內部的 上下頁事件註冊到LearningUnit  及 上下頁參數丟給LearningUnit
            mobjMultiPagedLUCalledInfo.NextOnTapHandlerRef = CallbackObj.NextOnTapHandlerRef
            mobjMultiPagedLUCalledInfo.PrevOnTapHandlerRef = CallbackObj.PrevOnTapHandlerRef
            mobjMultiPagedLUCalledInfo.CanBePrev = CallbackObj.CanBePrev
            mobjMultiPagedLUCalledInfo.CanBeNext = CallbackObj.CanBeNext
        }
        else if (CallbackObj.Action === "UpdateCanBeNavigatedInMultiPagedLU")
        {
            mobjMultiPagedLUCalledInfo.CanBePrev = CallbackObj.CanBePrev
            mobjMultiPagedLUCalledInfo.CanBeNext = CallbackObj.CanBeNext
        }
        else if (CallbackObj.Action === "GoToLU")
        {
            // 從LU裡面 要求切換LU e.g. 從
            let strLUCatSeqNo = CallbackObj.LUCatSeqNo.toString().PadLeft(2)
            console.log("GoToLU.strLUCatSeqNo: ", strLUCatSeqNo)
            setLUSeqNo(strLUCatSeqNo)
        }

        // #region History Window
        else if (CallbackObj.Action === "HistoryWindowOpen")
        {
            console.log("HistoryWindowOpen")
            mobjCallerInfoForHistoryWindow.CallbackRef = CallbackObj.CallbackRef
            // CallbackObj.AssigementHistoryList
            mobjCallerInfoForHistoryWindow.LessonID = CallbackObj.LessonID
            mobjCallerInfoForHistoryWindow.AssigementHistoryList = CallbackObj.AssigementHistoryList
            mobjCallerInfoForHistoryWindow.AssignmentTempAns = CallbackObj.AssignmentTempAns

            setShowHistoryWindow(true)
        }
        else if (CallbackObj.Action === "HistoryWindowClose")
        {
            setShowHistoryWindow(false)
        }
        else if (CallbackObj.Action === "HistoryWindowDetail")
        {
            let objCallbackData = {
                "Action": "HistoryWindowDetail",
                "AssignmentIndex": CallbackObj.AssignmentIndex
            }
            console.log(COMP_NAME + ".objCallbackData: ", objCallbackData)

            mobjCallerInfoForHistoryWindow.CallbackRef(objCallbackData)
            setShowHistoryWindow(false)
        }
        else if (CallbackObj.Action === "HistoryWindowLastSaved")
        {
            let objCallbackData = {
                "Action": "HistoryWindowLastSaved"
            }
            console.log(COMP_NAME + ".objCallbackData: ", objCallbackData)
            mobjCallerInfoForHistoryWindow.CallbackRef(objCallbackData)
            setShowHistoryWindow(false)
        }
        // #endregion History Window

        // #region Image Editor Window
        else if (CallbackObj.Action === "ImageEditorWindowOpen")
        {
            console.log("ImageEditorWindowOpen")
            mobjCallerInfoForImageEditorWindow.CallbackRef = CallbackObj.CallbackRef
            mobjCallerInfoForImageEditorWindow.Arguments = CallbackObj.Arguments
            setShowImageEditorWindow(true)
        }
        else if (CallbackObj.Action === "ImageEditorWindowCloseWithoutImage")
        {
            setShowImageEditorWindow(false)
            let objCallbackData = {
                "Action": "ImageEditorWindowCloseWithoutImage",
            }
            console.log(COMP_NAME + ".objCallbackData: ", objCallbackData)

            mobjCallerInfoForImageEditorWindow.CallbackRef(objCallbackData)
        }
        else if (CallbackObj.Action === "ImageEditorWindowCloseWithImage")
        {
            setShowImageEditorWindow(false)
            let objCallbackData = {
                "Action": "ImageEditorWindowCloseWithImage",
                "Arguments": CallbackObj.Arguments
            }
            console.log(COMP_NAME + ".objCallbackData: ", objCallbackData)

            mobjCallerInfoForImageEditorWindow.CallbackRef(objCallbackData)
        }
        // #endregion Image Editor Window

        // #region Stroke Window
        else if (CallbackObj.Action === "StrokeWindowOpen")
        {
            console.log("StrokeWindowOpen.CallbackObj: ", CallbackObj)
            mobjCallerInfoForStrokeWindow.CallbackRef = CallbackObj.CallbackRef
            mobjCallerInfoForStrokeWindow.Arguments = CallbackObj.Arguments
            setShowStrokeWindow(true)
        }
        else if (CallbackObj.Action === "StrokeWindowClose")
        {
            console.log("StrokeWindowClose.CallbackObj: ", CallbackObj)
            mobjCallerInfoForStrokeWindow.CallbackRef(CallbackObj)
            setShowStrokeWindow(false)
        }
        // #endregion Stroke Window

        // #region Audio Recording Window
        else if (CallbackObj.Action === "AudioRecordingWindowOpen")
        {
            console.log("AudioRecordingWindowOpen.CallbackObj: ", CallbackObj)
            mobjCallerInfoForAudioRecorderWindow.CallbackRef = CallbackObj.CallbackRef
            // mobjCallerInfoForAudioRecorderWindow.Arguments = CallbackObj.Arguments

            if (!window.gSession.App.InApp)
            {
                // Web
                setShowAudioRecorderWindow(true)
            }
            else
            {
                // App
                if (window.gSession.App.iOSNewGateway)
                {
                    // SwiftUI
                    console.log("SwiftUI")
                    setShowAudioRecorderWindow(true)
                }
                else
                {
                    console.log("Not SwiftUI")
                    CallAppOpenAudioRecorder()
                }
            }
        }
        else if (
            (CallbackObj.Action === "AudioRecordingWindowCloseWithoutResult") ||
            (CallbackObj.Action === "AudioRecordingWindowCloseWithResult")
            )
        {
            console.log("AudioRecordingWindowClose.CallbackObj: ", CallbackObj)
            mobjCallerInfoForAudioRecorderWindow.CallbackRef(CallbackObj)
            setShowAudioRecorderWindow(false)
        }

        // #endregion Audio Recording Window

        // #region Image Display Window
        else if (CallbackObj.Action === "OpenShowImageDisplayWindow")
        {
            // mobjCallerInfoForImageDisplayWindow.CallbackRef = CallbackObj.CallbackRef
            mobjCallerInfoForImageDisplayWindow.Arguments = CallbackObj.Arguments

            setShowImageDisplayWindow(true)
        }
        else if (CallbackObj.Action === "CloseShowImageDisplayWindow")
        {
            mobjShowComponentParam = null
            setShowImageDisplayWindow(false)
        }
        // #endregion Image Display Window

        // #region Video Player Window
        else if (CallbackObj.Action === "OpenShowViderPlayerWindow")
        {
            mobjCallerInfoForVideoPlayerWindow.Arguments = CallbackObj.Arguments
            setShowViderPlayerWindow(true)
        }
        else if (CallbackObj.Action === "CloseShowViderPlayerWindow")
        {
            mobjCallerInfoForVideoPlayerWindow = {
                CallbackRef: null,
                Arguments: null
            }
            setShowViderPlayerWindow(false)
        }
        // #endregion Video Player Window

        // #region Learning Unit Tool Tip
        else if (CallbackObj.Action === "CloseShowLearningUnitToolTip")
        {
            setIsShowLearningUnitToolTip(false)
        }
        // #endregion Learning Unit Tool Tip

        // #region ToolBarBottomUnit
        else if (CallbackObj.Action === "AssessmentsOnTap")
        {
            setToolMenu(false)
            GoToAssessments()
        }
        else if (CallbackObj.Action === "BCAppsOnTap")
        {
            setToolMenu(false)
            GoToBCApps()
        }
        else if (CallbackObj.Action === "HelpOnTap")
        {
            setToolMenu(false)
            GoToHelp()
        }
        else if (CallbackObj.Action === "OpenShowSettings")
        {
            mobjShowComponentParam = {
                "AuthorizedSubscription": null
            }
            setToolMenu(false)
            setIsShowSettings(true)
        }

        // #region Glossary
        else if (CallbackObj.Action === "RegisterGlossaryCallback")
        {
            console.log(COMP_NAME + ".RegisterGlossaryCallback")
            if (
                (typeof (CallbackObj.CallbackRef) !== "undefined") &&
                (CallbackObj.CallbackRef !== null)
                )
            {
                mobjCallerInfoForGlossaryWindow.CallbackRef = CallbackObj.CallbackRef
            }
        }
        else if (CallbackObj.Action === "UnregisterGlossaryCallback")
        {
            console.log(COMP_NAME + ".UnregisterUnregisterGlossaryCallback")
            mobjCallerInfoForGlossaryWindow.CallbackRef = null
        }
        else if (CallbackObj.Action === "OpenShowGlossary")
        {
            console.log("OpenShowGlossary.CallbackObj:", CallbackObj)

            mobjShowComponentParam = {
                "SearchText": ""
            }

            setToolMenu(false)

            // // 準備移除 App 取得資料 流程   Tim22.08.09
            // if (window.gSession.App.InApp)
            // {
            //     GetGlossaryFromAppProcessBegin(window.gSession.App.BookCatID)
            // }
            // else
            // {
            setIsShowGlossary(true)
            // }
        }
        else if (CallbackObj.Action === "OpenGlossaryWithSearchText")
        {
            console.log("OpenGlossaryWithSearchText.CallbackObj:", CallbackObj)

            mobjShowComponentParam = {
                "SearchText": CallbackObj.SearchText
            }
            console.log("OpenGlossaryWithSearchText.mobjShowComponentParam: ", mobjShowComponentParam)

            // // 準備移除 App 取得資料 流程   Tim22.08.09
            // if (window.gSession.App.InApp)
            // {
            //     GetGlossaryFromAppProcessBegin(window.gSession.App.BookCatID)
            // }
            // else
            // {
            setIsShowGlossary(true)
            // }
        }
        else if (CallbackObj.Action === "CloseShowGlossary")
        {
            mobjShowComponentParam = null
            setIsShowGlossary(false)
            if (mobjCallerInfoForGlossaryWindow.CallbackRef !== null)
            {
                mobjCallerInfoForGlossaryWindow.CallbackRef(CallbackObj)
            }
        }
        // #endregion Glossary

        else if (CallbackObj.Action === "OpenShowNoteList")
        {
            mobjShowComponentParam = null
            setToolMenu(false)
            setIsShowNoteList(true)
        }
        else if (CallbackObj.Action === "OpenShowResource")
        {
            mobjShowComponentParam = null
            setToolMenu(false)
            setIsShowResource(true)
        }
        // #endregion ToolBarBottomUnit

        // #region Change Page by Touch Event
        else if (CallbackObj.Action === "DisableChangePageByTouchEvent")
        {
            mblnChangePageByTouchEvent = false
        }
        else if (CallbackObj.Action === "EnableChangePageByTouchEvent")
        {
            mblnChangePageByTouchEvent = true
        }
        // #endregion Change Page by Touch Event

        else if (CallbackObj.Action === "CloseShowOpenWebWindow")
        {
            mobjShowComponentParam = null
            setIsShowOpenWebWindow(false)
        }
        else if (CallbackObj.Action === "CloseShowBCAppsWindows")
        {
            setIsShowBCAppsWindows(false)
        }
        else if (CallbackObj.Action === "CloseShowSettings")
        {
            mobjShowComponentParam = null
            setIsShowSettings(false)

            // CallbackObj.SettingsDirty = {
            //     // "ProfileEdit": false,
            //     // "PasswordChang": false,
            //     // "SubscriptionUpdate": false,
            //     "LangChange": false
            // }
            if (CallbackObj.SettingsDirty.LangChange)
            {
                console.log(COMP_NAME + ".CloseShowSettings SettingsDirty LangChange.")
                if (mfuncLanguageChangeHandler !== null)
                {
                    mfuncLanguageChangeHandler()
                }
            }
        }
        else if (CallbackObj.Action === "GoToLearningUnit4Settings")
        {
            mobjShowComponentParam = null
            setIsShowSettings(false)

            GotoLearningUnit(CallbackObj.LocationState.BookSeqNo
                , CallbackObj.LocationState.LessonID
                , CallbackObj.LocationState.LUCatSeqNo)
        }
        else if (CallbackObj.Action === "OpenShowResource4NoAuthorized")
        {
            mobjShowComponentParam = null
            setToolMenu(false)
            setIsShowSettings(false)
            setIsShowResource(true)
        }

        else if (CallbackObj.Action === "CloseShowNoteList")
        {
            mobjShowComponentParam = null
            setIsShowNoteList(false)
        }
        else if (CallbackObj.Action === "CloseShowResource")
        {
            mobjShowComponentParam = null
            setIsShowResource(false)
        }
        else if (CallbackObj.Action === "OpenSettings4NoAuthorized")
        {
            mobjShowComponentParam = {
                "AuthorizedSubscription": CallbackObj.AuthorizedSubscription
            }
            setIsShowSettings(true)
            setIsShowGlossary(false)
            setIsShowNoteList(false)
            setIsShowResource(false)
        }

        // #region ToolBarTopUnit
        else if (CallbackObj.Action === "AssignOnTap")
        {
            OpenLUAssign()
        }
        else if (CallbackObj.Action === "NoteOnTap")
        {
            OpenNoteEdit()
        }
        // #endregion ToolBarTopUnit

        else if (CallbackObj.Action === "CloseShowLUAssign")
        {
            setIsShowLUAssign(false)
        }
        else if (CallbackObj.Action === "CloseShowNoteEdit")
        {
            setIsShowNoteEdit(false)
        }

        else if (CallbackObj.Action === "TestSheetContextDirty")
        {
            console.log(COMP_NAME + ".TestSheetContextDirty")
            mblnIsTestSheetContextDirty = true
        }
        else if (CallbackObj.Action === "TestSheetContextNotDirty")
        {
            console.log(COMP_NAME + ".TestSheetContextNotDirty")
            mblnIsTestSheetContextDirty = false
        }

        else if (CallbackObj.Action === "RegisterLanguageChangeHandler")
        {
            console.log(COMP_NAME + ".RegisterLanguageChangeHandler")
            mfuncLanguageChangeHandler = CallbackObj.Function
        }
        else if (CallbackObj.Action === "UnregisterLanguageChangeHandler")
        {
            console.log(COMP_NAME + ".UnregisterLanguageChangeHandler")
            mfuncLanguageChangeHandler = null
        }

    } // end of ComponentCallback
    // #endregion Component Callback

    // // 準備移除 App 取得資料 流程   Tim22.08.09
    // // #region ComponentFuncEntry
    // /*===========================================
    // summary: 接回 Glossary Call AppDataAccess 的 入口
    // remarks: 000 Tim 2022/01/14 Create
    // ===========================================*/
    // function ComponentFuncEntry (CallObject)
    // {
    //     console.log(COMP_NAME + ".ComponentFuncEntry: ", CallObject)

    //     if (CallObject.Func === "GetGlossaryFromAppProcessEnd")
    //     {
    //         GetGlossaryFromAppProcessEnd()
    //     }
    //     else if (CallObject.Func === "GetGlossaryFromAppProcessError")
    //     {
    //         let objCallbackData = {
    //             "Action": "GetGlossaryFromAppProcessError",
    //             "ErrMsg": CallObject.ErrMsg
    //         }

    //         props.CallbackRef(objCallbackData)

    //         mobjShowComponentParam = null
    //     }
    //     else
    //     {
    //         console.log("unspported func: ", CallObject.Func)
    //     }
    // } // end of ComponentFuncEntry
    // // #endregion ComponentFuncEntry

    // #region Alert Call Back
    /*===========================================
    summary: 點選 Lessons 沒有授權 直接開授權頁面
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function NoAuthorizedGoToSubscriptionAlertCallBack(BtnObject)
    {
        console.log(COMP_NAME + ".NoAuthorizedGoToSubscriptionAlertCallBack: BtnObject: ", BtnObject)

        if (BtnObject.index === 1) // BTN_OK
        {
            // 改用新的方法開
            mobjShowComponentParam = {
                "AuthorizedSubscription": mobjAuthorizedSubscription
            }
            setIsShowSettings(true)
        }
        else
        {
            // 取消的話，清空資料
            mobjAuthorizedSubscription = null
        }
    } // end of NoAuthorizedGoToSubscriptionAlertCallBack
    // #endregion Alert Call Back

    // #region Other Functions

    function ProcessNext()
    {
        console.log(COMP_NAME + ".ProcessNext")

        if (MULTI_PAGES_LU_LIST.includes(lUSeqNo) && mobjMultiPagedLUCalledInfo.CanBeNext)
        {
            // 存在多頁時
            console.log("next clicked in multiple paged LU")
            // patch this event to LU compoment
            mobjMultiPagedLUCalledInfo.NextOnTapHandlerRef()
        }
        else
        {
            if (mblnIsTestSheetContextDirty)
            {
                // 有未Save或Submit的資料
                mintChangeLUFrom = ChangeLUFromEnum.NextOnTap
                AlertTestSheetContextDirty()
            }
            else
            {
                ChangeLUFromNextOnTap()
            }
        }
    }

    function ProcessPrevious()
    {
        console.log(COMP_NAME + ".ProcessPrevious")

        if (MULTI_PAGES_LU_LIST.includes(lUSeqNo) && mobjMultiPagedLUCalledInfo.CanBePrev)
        {
            console.log("prev clicked in multiple paged LU")
            mobjMultiPagedLUCalledInfo.PrevOnTapHandlerRef()
        }
        else
        {
            if (mblnIsTestSheetContextDirty)
            {
                // 有未Save或Submit的資料
                mintChangeLUFrom = ChangeLUFromEnum.PreviousOnTap
                AlertTestSheetContextDirty()
            }
            else
            {
                ChangeLUFromPreviousOnTap()
            }
        }
    }

    // #region Change LU From
    // 由觸發模式 來LU的動作
    function ChangeLU()
    {
        console.log(COMP_NAME + ".ChangeLU: ")

        switch (mintChangeLUFrom)
        {
            case ChangeLUFromEnum.NextOnTap:
                ChangeLUFromNextOnTap()
                break
            case ChangeLUFromEnum.PreviousOnTap:
                ChangeLUFromPreviousOnTap()
                break
            case ChangeLUFromEnum.SectionOnTap:
                mobjCurrentSectionIndexs = {
                    SectionIndex: mintTempSectionIndexSelected,
                    SubSectionIndex: 0,
                    SubSubSectionIndex: 0
                }
                ChangeLUFromSectionOnTap()
                mintTempSectionIndexSelected = -1 // Reset
                break
            case ChangeLUFromEnum.SubSectionOnTap:
                // SectionIndex 不改，只改 SubSectionIndex 以下
                mobjCurrentSectionIndexs.SubSectionIndex = mintTempSubSectionIndexSelected
                mobjCurrentSectionIndexs.SubSubSectionIndex = 0
                ChangeLUFromSubSectionOnTap()
                mintTempSubSectionIndexSelected = -1 // Reset
                break
            default:
                console.log("未指定換LU的來源")
        }

        mintChangeLUFrom = ChangeLUFromEnum.None
    }

    function ChangeLUFromNextOnTap()
    {
        console.log(COMP_NAME + ".ChangeLUFromNextOnTap: ")

        console.log("current LU: ", lUSeqNo)
        console.log("next clicked in single paged LU")
        // let's go to next LU
        GoToNextLU()
    }

    function ChangeLUFromPreviousOnTap()
    {
        console.log(COMP_NAME + ".ChangeLUFromPreviousOnTap: ")
        console.log("current LU: ", lUSeqNo)
        console.log("prev clicked in single paged LU")
        // let's go to previous LU
        GoToPrevLU()
    }

    function ChangeLUFromSectionOnTap()
    {
        console.log(COMP_NAME + ".ChangeLUFromSectionOnTap: ")

        console.log("mobjCurrentSectionIndexs: ", mobjCurrentSectionIndexs)
        ChangeLUViaSenctionIndex(mobjCurrentSectionIndexs)
    }

    function ChangeLUFromSubSectionOnTap()
    {
        console.log(COMP_NAME + ".ChangeLUFromSubSectionOnTap: ")
        console.log("mobjCurrentSectionIndexs: ", mobjCurrentSectionIndexs)
        ChangeLUViaSenctionIndex(mobjCurrentSectionIndexs)
    }

    // #endregion Change LU From

    // 
    /*===========================================
    summary: 儲存此使用者 最後一次存取的LU是哪一個
    remarks: 000 Jeff 2022/01/13 Tim幫忙註解
             001 Tim 2022/01/13 實作
    ===========================================*/
    function SetLastAccessLU(LUCatSeqNo)
    {
        console.log(COMP_NAME + ".SetLastAccessLU: ", LUCatSeqNo, props.location.state.LessonID)

        // LastAccessBookCategoryID: "03"
        // LastAccessBookSeqNo: "01"
        // LastAccessLUSeqNo: "01"
        // LastAccessLessonID: "03001"
        // LastAccessSectionSeqNo: "01"
        // LastAccessSubSectionSeqNo: "01"
        // LastAccessSubSubSectionSeqNo: null

        if (
            (typeof (window.gSession.Acc.Dashboard) !== 'undefined') &&
            (window.gSession.Acc.Dashboard !== null)
            )
        {
            window.gSession.Acc.Dashboard.LastAccessBookCategoryID = window.gSession.App.BookCatID.toString().PadLeft(2)    // 左邊補零 Format "01
            window.gSession.Acc.Dashboard.LastAccessBookSeqNo = mstrBookSeqNo
            window.gSession.Acc.Dashboard.LastAccessLessonID = props.location.state.LessonID.toString().PadLeft(5)          // 左邊補零 Format "01001"
            window.gSession.Acc.Dashboard.LastAccessLUSeqNo = LUCatSeqNo

            // Tim22.01.13
            // 更新時，後端 會依照 Lesson 跟 LUCategoryID
            // 去找到 LastAccessSectionSeqNo LastAccessSubSectionSeqNo LastAccessSubSubSectionSeqNo
            // 所以 重新撈取 GetAccountDashboard 就會得到 完整資料

            // let objLUInfo = window.gSession.App.CurrentLesson.Def.LearningUnit.find(LU => LU.LUCatSeqNo === LUCatSeqNo)

            // if (
            //     (typeof(objLUInfo) !== 'undefined') &&
            //     (objLUInfo !== null)
            //     )
            // {
            //     // LUCatSeqNo: "01"
            //     // SectionSeqNo: "01"
            //     // SubSectionSeqNo: "01"
            //     // SubSubSectionSeqNo: null
            //     window.gSession.Acc.Dashboard.LastAccessSectionSeqNo = objLUInfo.SectionSeqNo
            //     window.gSession.Acc.Dashboard.LastAccessSubSectionSeqNo = objLUInfo.SubSectionSeqNo
            //     window.gSession.Acc.Dashboard.LastAccessSubSubSectionSeqNo = objLUInfo.SubSubSectionSeqNo
            // }
            // else
            // {
            //     window.gSession.Acc.Dashboard.LastAccessSectionSeqNo = null
            //     window.gSession.Acc.Dashboard.LastAccessSubSectionSeqNo = null
            //     window.gSession.Acc.Dashboard.LastAccessSubSubSectionSeqNo = null
            // }

            mobjCallParam = {
                "BookCategoryID": window.gSession.Acc.Dashboard.LastAccessBookCategoryID,
                "LessonID": window.gSession.Acc.Dashboard.LastAccessLessonID,
                "LUCategoryID": window.gSession.Acc.Dashboard.LastAccessLUSeqNo
            }

            UpdateLastAccessedLU()
        } // end of if (window.gSession.Acc.Dashboard !== null)
    } // end of SetLastAccessLU

    /*===========================================
    summary: App錄音使用App的UI
    remarks: 000 Jeff 202X/XX/XX Create
             001 Tim 2023/06/14 處理 AppCallbackRef 反註冊
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function CallAppOpenAudioRecorder()
    {
        console.log(COMP_NAME + ".CallAppOpenAudioRecorder: ")

        // and call App to open Audio Recorder
        var intAction = window.gConst.ACTION_AUDIO_RECORD;
        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway, BackFromAppCallbackOpenAudioRecorder)
        ClientGatewayInPackage.CallApp(strQueryString, BackFromAppCallbackOpenAudioRecorder)
    } // end of CallAppOpenAudioRecorder

    // App錄音使用App的UI
    // remarks: 001 Tim 2023/06/14 處理 AppCallbackRef 反註冊
    function BackFromAppCallbackOpenAudioRecorder(ReturnData)
    {
        console.log(COMP_NAME + ".BackFromAppCallbackOpenAudioRecorder: ", ReturnData)

        let CallbackObj = {
            Action: (ReturnData.Data === "") ? "AudioRecordingWindowCloseWithoutResult" : "AudioRecordingWindowCloseWithResult",
            AudioBase64: (ReturnData.Data === "") ? "" : ("data:audio/mp3;base64," + ReturnData.Data)
        }
        mobjCallerInfoForAudioRecorderWindow.CallbackRef(CallbackObj)

        // window.gSession.App.AppCallbackRef = null
    }

    /*===========================================
    summary: 取得 Lesson 標題資料
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function GetLessonTitle(BookSeqNo)
    {
        console.log(COMP_NAME + ".GetLessonTitle")

        let objLessonTitle = null
        let arrLessonTitle = []
        let arrLesson = window.gSession.App.BookDef[BookSeqNo].Lesson

        console.log(COMP_NAME + ".GetLessonTitle arrLesson: ", arrLesson)

        let blnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, parseInt(BookSeqNo))
        console.log(COMP_NAME + ".GetLessonTitle blnExpired: ", blnExpired)

        let intIndex = 0
        let intCount = arrLesson.length

        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            objLessonTitle = {
                "TitleEN": arrLesson[intIndex].PrefixName + ": " + arrLesson[intIndex].Name,
                "TitleCN": "",
                "Expired": blnExpired,
                "LessonID": arrLesson[intIndex].ID
            }

            // 每一本書 第一課 都免費給他使用
            if (intIndex === 0)
            {
                objLessonTitle.Expired = false
            }

            if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
            {
                objLessonTitle.TitleCN = arrLesson[intIndex].MajorPrefixName + ": " + arrLesson[intIndex].MajorName
            }
            else
            {
                objLessonTitle.TitleCN = arrLesson[intIndex].MinorPrefixName + ": " + arrLesson[intIndex].MinorName
            }

            arrLessonTitle.push(objLessonTitle)
        }

        return arrLessonTitle
    } // end of GetLessonTitle

    /*===========================================
    summary: 切換到 該Lesson 前往 Learning Unit 頁面
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function GotoLearningUnit(BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GotoLearningUnit: ", BookSeqNo, LessonID, LUCatSeqNo)

        let strLessonID = LessonID.PadLeft(5)
        let objLocationState = {
            "BookSeqNo": parseInt(BookSeqNo),
            "LessonID": strLessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo)
        }
        console.log("GotoLearningUnit objLocationState: ", objLocationState)

        RoutePathLibs.Route2Path(props.history, "/Lessons", objLocationState)
    } // end of GotoLearningUnit

    /*===========================================
    summary: 沒有授權 的 後續流程，先走購買，再回到 原本選擇的Lesson
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function NoAuthorizedProcess(LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".NoAuthorizedProcess: Not Authorized!")

        console.log(COMP_NAME + ".NoAuthorizedProcess: App.BookCatID: ", window.gSession.App.BookCatID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: mstrBookSeqNo: ", mstrBookSeqNo)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LessonID: ", LessonID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LUCatSeqNo: ", LUCatSeqNo)

        // 先不串 GoogleClass 配對這塊
        mobjAuthorizedSubscription = {
            "BookCatID": parseInt(window.gSession.App.BookCatID),
            "BookSeqNo": mstrBookSeqNo,
            "LessonID": LessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo),
            "SubscriptionType": -1
        }

        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.ERR_GoToLUNoAuthorizedGoToIAP,
            ShowCloseButton: false,
            CallbackRef: NoAuthorizedGoToSubscriptionAlertCallBack,
            Buttons: [
                {
                    Text: window.gAppUI.BTN_Cancel,
                    AutoFocus: false
                },
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    } // end of NoAuthorizedProcess

    /*===========================================
    summary: 前往 Assessments的 連結
    remarks: 000 Tim 2021/12/06 Create
             001 Tim 2023/06/14 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
             003 Tim 2023/09/07 iOSNewGateway 改寫 
                                不使用 之前 會開下載視窗的流程
                                改用 開其他App的新流程
    ===========================================*/
    function GoToAssessments()
    {
        const FUNC_NAME = GoToAssessments.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": ", window.gSession.Acc.Preferences)

        let strTimeZoneValue = "";
        if (
            (typeof (window.gSession.Acc.Preferences) !== 'undefined') &&
            (window.gSession.Acc.Preferences !== null) &&
            (typeof (window.gSession.Acc.Preferences.TimeZone) !== 'undefined') &&
            (window.gSession.Acc.Preferences.TimeZone !== null) &&
            (window.gSession.Acc.Preferences.TimeZone !== -1)
            )
        {
            strTimeZoneValue = TimeZoneLibs.GetTimeZoneValueByID(window.gSession.Acc.Preferences.TimeZone)
        } // end of if (window.gSession.Acc.Preferences.TimeZone !== -1)
        console.log(COMP_NAME + "." + FUNC_NAME + " strTimeZoneValue: ", strTimeZoneValue)

        let intClassID = -1

        if (
            (window.gSession.Acc.CurrentClassIndex >= 0) &&
            (window.gSession.Acc.Class !== null) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) !== 'undefined') &&
            (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)
            )
        {
            intClassID = parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID)
        } // end of if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)

        if (!window.gSession.App.InApp)
        {
            console.log(COMP_NAME + "." + FUNC_NAME + " not In App")
            let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)

            console.log(COMP_NAME + "." + FUNC_NAME + " Acc.Class: ", window.gSession.Acc.Class)

            // 增加參數 AccountID   Tim16.05.19
            let strQueryString = "Credential=" + window.gSession.Acc.Credential
            strQueryString += "&BackRoute="
            strQueryString += "&ClassName=" + window.gSession.Acc.Profile.ClassName
            strQueryString += "&LoginName=" + window.gSession.Acc.LoginName
            strQueryString += "&AccountID=" + window.gSession.Acc.ID
            strQueryString += "&CurrentClassID=" + intClassID
            strQueryString += "&TimeZone=" + strTimeZoneValue
            strQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
            strQueryString += "&lang=" + window.gSession.Acc.Preferences.Lang
            strQueryString += "&Env=" + intEnv

            let strWebSiteUrl = window.gConfig.AssessmentUrl

            mobjShowComponentParam = {
                "WebSiteUrl": strWebSiteUrl,
                "ArgList": strQueryString,
                "IsAssessments": true
            }
            setIsShowOpenWebWindow(true)
        } // end of if (!window.gSession.App.InApp)
        else
        {
            // WebCallApp

            if (window.gSession.App.iOSNewGateway)
            {
                // 不使用 之前 會開下載視窗的流程，改用 開其他App的新流程   Tim23.09.07
                let strUrl = window.gConfig.DCPAssessmentUrl
                
                let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)

                let strParmsQueryString = "CurrentClassID=" + intClassID    // 可以將 CurrentClassID 傳過去，方便進入該Class
                strParmsQueryString += "&TimeZone=" + strTimeZoneValue
                strParmsQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
                strParmsQueryString += "&LoginName=" + window.gSession.Acc.LoginName
                strParmsQueryString += "&AccountID=" + window.gSession.Acc.ID
                strParmsQueryString += "&Credential=" + window.gSession.Acc.Credential
                strParmsQueryString += "&Env=" + intEnv

                // In App
                var strWebSiteUrl = strUrl + "?" + strParmsQueryString
                console.log(COMP_NAME + "." + FUNC_NAME + " CallApp strWebSiteUrl: ", strWebSiteUrl)

                let intAction = window.gConst.ACTION_OPEN_BROWSER
                let strQueryString = "Action=" + intAction
                strQueryString += "&Credential=" + window.gSession.Acc.Credential
                strQueryString += "&BackRoute="
                strQueryString += "&Url=" + encodeURIComponent(strWebSiteUrl)

                console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString: ", strQueryString)

                ClientGatewayInPackage.CallApp(strQueryString)

                // let intAction = window.gConst.ACTION_OPEN_ANOTHER_APP_BY_URL_SCHEMES

                // let strParmsQueryString = "CurrentClassID=" + intClassID    // 可以將 CurrentClassID 傳過去，方便進入該Class
                // strParmsQueryString += "&TimeZone=" + strTimeZoneValue
                // strParmsQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
                // strParmsQueryString += "&ClassName=" + window.gSession.Acc.Profile.ClassName
                // strParmsQueryString += "&UserName=" + window.gSession.Acc.Profile.UserName
                // strParmsQueryString += "&LoginName=" + window.gSession.Acc.LoginName
                // strParmsQueryString += "&AccountID=" + window.gSession.Acc.ID
                // console.log(COMP_NAME + "." + FUNC_NAME + " iOSNewGateway strParmsQueryString: ", strParmsQueryString)

                // let strURL = window.gAppURLSchemes.DCPAssessment + "://?" + strParmsQueryString
                // let strQueryString = "Action=" + intAction
                // strQueryString += "&Credential=" + window.gSession.Acc.Credential
                // strQueryString += "&BackRoute="
                // strQueryString += "&AppUrl4Open=" + encodeURIComponent(strURL)
                // console.log(COMP_NAME + "." + FUNC_NAME + " iOSNewGateway strQueryString: ", strQueryString)

                // // 已有安裝 DCPAssessment App 且 可成功直接開 DCPAssessment App 時 不回傳
                // // 未安裝 DCPAssessment App時 會開啟失敗才回傳
                // // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway, BackFromAppCallbackGoToDCPAssessments)
                // ClientGatewayInPackage.CallApp(strQueryString, BackFromAppCallbackGoToDCPAssessments)
            } // end of if (window.gSession.App.iOSNewGateway)
            else
            {

                // call App (DCP)
                let intAction = window.gConst.ACTION_OPEN_DCP_ASSESSMENT

                //  可以將 CurrentClassID 傳過去，方便進入該Class
                let strQueryString = "Action=" + intAction
                strQueryString += "&Credential=" + window.gSession.Acc.Credential
                strQueryString += "&BackRoute="
                strQueryString += "&CurrentClassID=" + intClassID
                strQueryString += "&TimeZone=" + strTimeZoneValue
                strQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
                strQueryString += "&ClassName=" + window.gSession.Acc.Profile.ClassName
                strQueryString += "&LoginName=" + window.gSession.Acc.LoginName
                strQueryString += "&AccountID=" + window.gSession.Acc.ID

                console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString: ", strQueryString)

                // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
                ClientGatewayInPackage.CallApp(strQueryString)
            } // end of else
        } // end of else
    } // end of GoToAssessments

    // // remarks: 001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    // // remarks: 002 Tim 2023/09/07 開啟DCPAssessmentUrl App
    // //                             不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
    // function BackFromAppCallbackGoToDCPAssessments(ReturnData)
    // {
    //     console.log(COMP_NAME + ".BackFromAppCallbackGoToDCPAssessments: ", ReturnData)

    //     if (
    //         (typeof (ReturnData) !== 'undefined') &&
    //         (ReturnData !== null) &&
    //         (typeof (ReturnData.Status) !== 'undefined') &&
    //         (ReturnData.Status !== null)
    //         )
    //     {
    //         if (parseInt(ReturnData.Status) === 2)
    //         {
    //             console.log("show download another app window")
    //             // 未安裝 DCPAssessment 打開下載畫面
    //             setShowDownloadAnotherAppWindow(true)
    //         }
    //     }

    //     // window.gSession.App.AppCallbackRef = null
    // }

    /*===========================================
    summary: 開啟 BCApps
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function GoToBCApps()
    {
        console.log(COMP_NAME + ".GoToBCApps")

        setIsShowBCAppsWindows(true)
    } // end of GoToBCApps

    /*===========================================
    summary: 前往 Help的 連結
    remarks: 000 Tim 2021/12/06 Create
             001 Tim 2023/06/14 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function GoToHelp()
    {
        console.log(COMP_NAME + ".GoToHelp")

        let strWebSiteUrl = window.gConfig.HelpUrl

        if (!window.gSession.App.InApp)
        {
            // 另開始窗
            window.open(strWebSiteUrl)
        } // end of if (!window.gSession.App.InApp)
        else
        {
            // In App
            let intAction = window.gConst.ACTION_OPEN_BROWSER;
            let strQueryString = "Action=" + intAction
            strQueryString += "&Credential=" + window.gSession.Acc.Credential
            strQueryString += "&BackRoute="
            strQueryString += "&Url=" + encodeURIComponent(strWebSiteUrl)

            // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
            ClientGatewayInPackage.CallApp(strQueryString)
        } // end of else
    } // end of GoToHelp

    /*===========================================
    summary: 開啟 指派此單元的 Assign考卷
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function OpenLUAssign()
    {
        console.log(COMP_NAME + ".OpenLUAssign")

        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg)
        }
        else
        {
            let strMenuName = "";
            let strLessonID = props.location.state.LessonID.toString().PadLeft(5);    // 左邊補零 Format "01001"
            let strLUCatSeqNo = mstrStateLUCatSeqNo

            // let objSectionIndexs = mobjSectionLULookUpTable.LookUpTable.find(Item => Item.LUCatSeqNo === mstrStateLUCatSeqNo).SectionIndexs
            let objSectionIndexs = null
            let objLookUpItem = mobjSectionLULookUpTable.LookUpTable.find(Item => Item.LUCatSeqNo === mstrStateLUCatSeqNo)
            if (
                (typeof (objLookUpItem) !== "undefined") &&
                (objLookUpItem !== null)
                )
            {
                objSectionIndexs = objLookUpItem.SectionIndexs
            }
            console.log("objSectionIndexs: ", objSectionIndexs)
            // SectionIndex: 3
            // SubSectionIndex: 2
            // SubSubSectionIndex: -1

            let arrSection = window.gSession.App.BookDef[mstrBookSeqNo].Section
            let strSectionName = arrSection[objSectionIndexs.SectionIndex].Name
            console.log(COMP_NAME + ".OpenLUAssign strSectionName: ", strSectionName)

            let arrSubSection = arrSection[objSectionIndexs.SectionIndex].SubSection
            let strSubSectionName = arrSubSection[objSectionIndexs.SubSectionIndex].Name
            console.log(COMP_NAME + ".OpenLUAssign strSubSectionName", strSubSectionName)
            strMenuName = arrSubSection[objSectionIndexs.SubSectionIndex].MenuName
            console.log(COMP_NAME + ".OpenLUAssign 1 strMenuName: ", strMenuName)

            let strSubSubSectionName = ''
            if (
                (objSectionIndexs.SubSubSectionIndex > 0) &&
                (typeof (arrSubSection[objSectionIndexs.SubSectionIndex].SubSubSection) !== 'undefined') &&
                (arrSubSection[objSectionIndexs.SubSectionIndex].SubSubSection !== null)
                )
            {
                let arrSubSubSection = arrSubSection[objSectionIndexs.SubSectionIndex].SubSubSection
                strSubSubSectionName = arrSubSubSection[objSectionIndexs.SubSubSectionIndex].Name
                strMenuName = strSubSubSectionName
                console.log(COMP_NAME + ".OpenLUAssign 2 strMenuName: ", strMenuName)
            }
            console.log("strSubSubSectionName: ", strSubSubSectionName)

            mobjShowComponentParam = {
                "LessonID": strLessonID,
                "LUCatSeqNo": strLUCatSeqNo,
                "SectionName": strSectionName,
                "SubSectionName": strSubSectionName,
                "SubSubSectionName": strSubSubSectionName,
                "MenuName": strMenuName
            }

            setToolMenu(false)
            setIsShowLUAssign(true)
        }
    } // end of OpenLUAssign

    /*===========================================
    summary: 開啟 此單元的 Note編輯
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function OpenNoteEdit()
    {
        console.log(COMP_NAME + ".OpenNoteEdit")

        mobjShowComponentParam = {
            "BookCatID": window.gSession.App.BookCatID,
            "LessonID": props.location.state.LessonID,
            "LUCatSeqNo": mstrStateLUCatSeqNo
        }

        setIsShowNoteEdit(true)
        setToolMenu(false)
    } // end of OpenNoteEdit
    // #endregion Other Functions

    // #region Get ClassName or Style
    /*===========================================
    summary: 取得 Section選單 Cls
      param: 

    retruns: 
    remarks: 000 Tim 2020/11/11 Create
    ===========================================*/
    function GetSectionCls(CurrSectionIndex, SectionIndex, Section)
    {
        console.log(COMP_NAME + ".GetSectionCls");

        let objCls = cssLearningUnit.divSection

        switch (Section.Name)
        {
            case "Language Notes":
                objCls = cssLearningUnit.divSection4LanguageNotes
                break
            case "Practice":
                objCls = cssLearningUnit.divSection4Practice
                break
            case "Can Do Statements":
                objCls = cssLearningUnit.divSection4CanDoStatements
                break
            case "Lesson":
            case "Cultural Notes":
            case "Review":
            default:
                objCls = cssLearningUnit.divSection
                break
        }

        if (CurrSectionIndex === SectionIndex)
        {
            switch (Section.Name)
            {
                case "Language Notes":
                    objCls = cssLearningUnit.divSectionSelected4LanguageNotes
                    break
                case "Practice":
                    objCls = cssLearningUnit.divSectionSelected4Practice
                    break
                case "Can Do Statements":
                    objCls = cssLearningUnit.divSectionSelected4CanDoStatements
                    break
                case "Lesson":
                case "Cultural Notes":
                case "Review":
                default:
                    objCls = cssLearningUnit.divSectionSelected
                    break
            }
        }

        return objCls
    }

    // summary: 取得 SubSection選單 Cls
    function GetSubSectionCls(CurrSubSectionIndex, SubSectionIndex, SubSection)
    {
        console.log(COMP_NAME + ".GetSubSectionCls");

        let objCls = cssLearningUnit.divSubSection

        switch (SubSection.MenuName)
        {
            case "Animation":
            case "Illustration":
            case "Lesson Text":
            case "Language Tips":
            case "Discovering China":
            case "Listening":
            case "Writing":
                objCls = cssLearningUnit.divSubSectionFor11Padding
                break
            case "Reading":
                objCls = cssLearningUnit.divSubSectionFor9Padding
                break
            case "Activity":
                objCls = cssLearningUnit.divSubSectionFor12Padding
                break
            case "Goals":
            case "Cultural Notes":
            case "Review":
            default:
                objCls = cssLearningUnit.divSubSection
                break
        }

        if (CurrSubSectionIndex === SubSectionIndex)
        {
            switch (SubSection.MenuName)
            {
                case "Animation":
                case "Illustration":
                case "Lesson Text":
                case "Language Tips":
                case "Discovering China":
                case "Listening":
                case "Writing":
                    objCls = cssLearningUnit.divSubSectionSelectedFor11Padding
                    break
                case "Reading":
                    objCls = cssLearningUnit.divSubSectionSelectedFor9Padding
                    break
                case "Activity":
                    objCls = cssLearningUnit.divSubSectionSelectedFor12Padding
                    break
                case "Goals":
                case "Cultural Notes":
                case "Review":
                default:
                    objCls = cssLearningUnit.divSubSectionSelected
                    break
            }
        }

        return objCls
    }
    // #endregion Get ClassName or Style

    function GetNextCls()
    {
        console.log(COMP_NAME + ".GetNextCls");

        let objCls = null
        let blnCanBeNext = CanBeNext()

        if (window.gSession.App.InApp)
        {
            objCls = cssLearningUnit.divHide
        }
        else if (blnCanBeNext)
        {
            objCls = cssLearningUnit.divNext
        }
        else
        {
            objCls = cssLearningUnit.divNextDisable
        }

        return objCls
    }

    function CanBeNext()
    {
        console.log(COMP_NAME + ".CanBeNext");

        let blnCanBeNext = false
        let intCurrentLUIndexInLookUpTable = GetLUIndexInLookUpTable(lUSeqNo)

        if (intCurrentLUIndexInLookUpTable < mintTotalLUs - 1)
        {
            blnCanBeNext = true
        }
        else
        {
            if (MULTI_PAGES_LU_LIST.includes(lUSeqNo))
            {
                blnCanBeNext = mobjMultiPagedLUCalledInfo.CanBeNext
            }
        }

        return blnCanBeNext
    }
    
    function CanBePrev()
    {
        console.log(COMP_NAME + ".CanBePrev");

        let blnCanBePrev = false
        let intCurrentLUIndexInLookUpTable = GetLUIndexInLookUpTable(lUSeqNo)

        if (intCurrentLUIndexInLookUpTable > 0)
        {
            blnCanBePrev = true
        }
        else
        {
            if (MULTI_PAGES_LU_LIST.includes(lUSeqNo))
            {
                blnCanBePrev = mobjMultiPagedLUCalledInfo.CanBePrev
            }
        }

        return blnCanBePrev
    }

    // #region Get ClassName

    function GetPreviousCls()
    {
        console.log(COMP_NAME + ".GetPreviousCls");

        let objCls = null
        let blnCanBePrev = CanBePrev()

        if (window.gSession.App.InApp)
        {
            objCls = cssLearningUnit.divHide
        }
        else if (blnCanBePrev)
        {
            objCls = cssLearningUnit.divPrevious
        }
        else
        {
            objCls = cssLearningUnit.divPreviousDisable
        }

        return objCls
    }

    /*===========================================
    summary: 取得 Lesson 元件 Cls
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function GetLessonUnitCls(Expired)
    {
        let objCls = cssLearningUnit.divLessonUnit

        // 如果 過期 就 Disable
        if (Expired)
        {
            objCls = cssLearningUnit.divLessonUnitDisable
        }

        return objCls
    } // end of GetLessonUnitCls

    /*===========================================
    summary: 取得 Lesson 元件 Cls
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function GetLessonTitleENCls(InApp)
    {
        let objCls = cssLearningUnit.divLessonTitleEN

        // 如果 過期 就 Disable
        if (InApp)
        {
            objCls = cssLearningUnit.divLessonTitleEN4InApp
        }

        return objCls
    } // end of GetLessonTitleENCls
    // #endregion Get ClassName


    // #region Web Service After Process
    /*===========================================
    summary: 儲存 使用者 最後點選的單元 後續流程
    remarks: 000 Tim 2022/01/13 Create
    ===========================================*/
    function UpdateLastAccessedLUAfterProcess()
    {
        // console.log(COMP_NAME + ".UpdateLastAccessedLUAfterProcess: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".UpdateLastAccessedLUAfterProcess BEGIN")

        mobjCallParam = null
    } // end of UpdateLastAccessedLUAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 儲存 使用者 最後點選的單元
    remarks: 000 Tim 2022/01/13 Create
    ===========================================*/
    function UpdateLastAccessedLU()
    {
        // console.log(COMP_NAME + ".UpdateLastAccessedLU: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".UpdateLastAccessedLU BEGIN")

        let objRetryFuncRef = UpdateLastAccessedLU
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = UpdateLastAccessedLUCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

            // // Open Loading mask with message
            // OpenLoadingMask(window.gAppUI.MSG_LoadMask_UpdateLastAccessedLU)

            let objCallData = {
                "Func": "UpdateLastAccessedLU",
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID,
                "LUCategoryID": mobjCallParam.LUCategoryID
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of UpdateLastAccessedLU

    /*===========================================
    summary: 儲存 使用者 最後點選的單元 Callback
    remarks: 000 Tim 2022/01/13 Create
    ===========================================*/
    function UpdateLastAccessedLUCallback(Return)
    {
        console.log(COMP_NAME + ".UpdateLastAccessedLUCallback: ", Return)

        // // Close Loading mask        
        // CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UpdateLastAccessedLU_No
        let strErrorTitle = window.gAppUI.ERR_UpdateLastAccessedLU_Title
        let strErrMsg = window.gAppUI.ERR_UpdateLastAccessedLU_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute)
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("UpdateLastAccessedLUCallback: ErrNo: ", Return.ErrNo)
            console.log("UpdateLastAccessedLUCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("UpdateLastAccessedLUCallback Return.Data", Return.Data)

            UpdateLastAccessedLUAfterProcess()
        }
    } // end of UpdateLastAccessedLUCallback
    // #endregion Web Service

    // // 準備移除 App 取得資料 流程   Tim22.08.09
    // // #region Call App
    // /*===========================================
    // summary: 取得 字彙表資料 流程 開始
    // remarks: 000 Tim 2022/01/14 Create
    // ===========================================*/
    // function GetGlossaryFromAppProcessBegin (BookCategoryID)
    // {
    //     console.log(COMP_NAME + ".GetGlossaryFromAppProcessBegin ", BookCategoryID)

    //     window.ComponentFuncEntry.GlossaryRef = ComponentFuncEntry

    //     AppDataAccess.GetGlossaryFromApp(BookCategoryID)
    // } // end of GetGlossaryFromAppProcessBegin

    // /*===========================================
    // summary: 取得 字彙表資料 流程 結束
    // remarks: 000 Tim 2022/01/14 Create
    // ===========================================*/
    // function GetGlossaryFromAppProcessEnd (CallbackObject)
    // {    
    //     setIsShowGlossary(true)
    // } // end of GetGlossaryFromAppProcessEnd
    // // #endregion Call App

    // #region Render
    /*===========================================
    summary: Render 此單元的 Note編輯 視窗 的顯示
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function RenderNoteEditWrapper(StateIsShowNoteEdit)
    {
        if (
            (mobjShowComponentParam !== null) &&
            (StateIsShowNoteEdit)
            )
        {
            return (
                <NoteEdit BookCatID={mobjShowComponentParam.BookCatID}
                    LessonID={mobjShowComponentParam.LessonID}
                    LUCatSeqNo={mobjShowComponentParam.LUCatSeqNo}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderNoteEditWrapper

    /*===========================================
    summary: Render 指派LU視窗 的顯示
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function RenderLUAssignWrapper(StateIsShowLUAssign)
    {
        if (
            (mobjShowComponentParam !== null) &&
            (StateIsShowLUAssign)
            )
        {
            return (
                <LUAssign LessonID={mobjShowComponentParam.LessonID}
                    LUCatSeqNo={mobjShowComponentParam.LUCatSeqNo}
                    SectionName={mobjShowComponentParam.SectionName}
                    SubSectionName={mobjShowComponentParam.SubSectionName}
                    SubSubSectionName={mobjShowComponentParam.SubSubSectionName}
                    MenuName={mobjShowComponentParam.MenuName}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderLUAssignWrapper

    /*===========================================
    summary: Render Settings 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderSettingsWrapper(StateIsShowSettings)
    {
        if (
            (mobjShowComponentParam !== null) &&
            (StateIsShowSettings)
            )
        {
            return (
                <Settings AuthorizedSubscription={mobjShowComponentParam.AuthorizedSubscription}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderSettingsWrapper

    /*===========================================
    summary: Render 字典 視窗 的顯示
    remarks: 000 Tim 2021/11/23 Create
    ===========================================*/
    function RenderGlossaryWrapper(StateIsShowGlossary)
    {
        if (StateIsShowGlossary)
        {
            // mobjShowComponentParam = {
            //     "SearchText": 
            // }
            return (
                <Glossary History={props.history}
                    ButtonType={window.gButtonTypeEnum.LearningUnit}
                    SearchText={mobjShowComponentParam.SearchText}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderGlossaryWrapper

    /*===========================================
    summary: Render 筆記列表 視窗 的顯示
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function RenderNoteListWrapper(StateIsShowNoteList)
    {
        if (StateIsShowNoteList)
        {
            return (
                <NoteList History={props.history}
                    ButtonType={window.gButtonTypeEnum.LearningUnit}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderNoteListWrapper

    /*===========================================
    summary: Render 資源下載視窗 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderResourceWrapper(StateIsShowResource)
    {
        if (StateIsShowResource)
        {
            return (
                <Resource CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderResourceWrapper

    /*===========================================
    summary: Render BCAppsWindows 的顯示
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function RenderBCAppsWindowsWrapper(StateIsShowBCAppsWindows)
    {
        if (StateIsShowBCAppsWindows)
        {
            return (
                <BCAppsWindows CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderBCAppsWindowsWrapper

    /*===========================================
    summary: Render OpenWebWindow 的顯示
    remarks: 000 Tim 2021/12/06 Create
    ===========================================*/
    function RenderOpenWebWindowWrapper(StateIsShowOpenWebWindow)
    {
        if (
            (mobjShowComponentParam !== null) &&
            (StateIsShowOpenWebWindow)
            )
        {
            return (
                <OpenWebWindow WebSiteUrl={mobjShowComponentParam.WebSiteUrl}
                    ArgList={mobjShowComponentParam.ArgList}
                    IsAssessments={mobjShowComponentParam.IsAssessments}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderOpenWebWindowWrapper

    function RenderLUContent(LUCatSeqNo)
    {
        console.log(COMP_NAME + ".RenderLUContent: ", LUCatSeqNo)

        console.log("mobjSectionLULookUpTable: ", mobjSectionLULookUpTable)

        // let objSectionIndexs = mobjSectionLULookUpTable.LookUpTable.find(Item => Item.LUCatSeqNo === LUCatSeqNo).SectionIndexs
        let objSectionIndexs = null
        let objLookUpItem = mobjSectionLULookUpTable.LookUpTable.find(Item => Item.LUCatSeqNo === LUCatSeqNo)
        if (
            (typeof (objLookUpItem) !== "undefined") &&
            (objLookUpItem !== null)
            )
        {
            objSectionIndexs = objLookUpItem.SectionIndexs
        }

        console.log("objSectionIndexs: ", objSectionIndexs)
        let objBlock = null

        // mintLUType = props.location.state.LUSeqNo
        let strLessonID = props.location.state.LessonID
        // mintLUType = window.gDCPLUEnum.LessonGoals // TEST: 想去哪一個 LU, 在這裡覆蓋

        // objLUInfo = window.gSession.App.CurrentLesson.Def.LearningUnit.find(LU => LU.LUCatSeqNo === strLUCatSeqNo)
        let objLUInfo = window.gSession.App.CurrentLesson.Def.LearningUnit.find(LU => LU.LUCatSeqNo === LUCatSeqNo)

        // richard 20211116 LU Fluency 需要的 Sentences 並不在自己的  LUInfo 裡面
        // 需要從 LU: LessonText 取得
        if (parseInt(LUCatSeqNo) === window.gDCPLUEnum.PracticeFluency)
        {
            let strLULessonText = window.gDCPLUEnum.LessonLessonText.toString().PadLeft(2)

            let objLULessonText = window.gSession.App.CurrentLesson.Def.LearningUnit.find(LU => LU.LUCatSeqNo === strLULessonText)
            let Sentence4ReadAloud = [].concat(objLULessonText.Sentence4ReadAloud)
            // let arrSentence = [].concat(objLULessonText.Sentence)
            Sentence4ReadAloud.forEach((Sentence4ReadAloud, Index) => {
                console.log("Sentence4ReadAloud: ", Sentence4ReadAloud, Index)

                // let intIndex4Text = -1
                let intIndex4Text = Sentence4ReadAloud.ParagraphIdx
                Sentence4ReadAloud.Character = objLULessonText.Sentence[intIndex4Text].Character
                if (Sentence4ReadAloud.AudioFN === "")
                {
                    // intIndex4Text = Sentence4ReadAloud.ParagraphIdx
                    Sentence4ReadAloud.AudioFN = objLULessonText.Sentence[intIndex4Text].AudioFN
                }
                // if (typeof(Sentence4ReadAloud.Character) === "undefined")
                // {
                // intIndex4Text = Sentence4ReadAloud.ParagraphIdx
                // Sentence4ReadAloud.Character = objLULessonText.Sentence[intIndex4Text].Character
                // }
            })

            // let arrSentence = window.gSession.App.CurrentLesson.Def.LearningUnit.find(LU => LU.LUCatSeqNo === strLULessonText).Sentence4ReadAloud
            objLUInfo.Sentence = Sentence4ReadAloud
        }
        else if (parseInt(LUCatSeqNo) === window.gDCPLUEnum.CanDoStatements)
        {
            let strLULessonGoals = window.gDCPLUEnum.LessonGoals.toString().PadLeft(2)
            let objLULessonGoals = window.gSession.App.CurrentLesson.Def.LearningUnit.find(LU => LU.LUCatSeqNo === strLULessonGoals)

            objLUInfo.Goals = objLULessonGoals.Goals
        }
        // console.log("strLUCatSeqNo: ", strLUCatSeqNo)
        console.log("objLUInfo: ", objLUInfo)

        // let objSubSectionDef = window.gSession.App.BookDef[mstrBookSeqNo].Section[objSectionIndexs.SectionIndex].SubSection[objSectionIndexs.SubSectionIndex]
        let objSubSectionDef = null
        if (objSectionIndexs !== null)
        {
            objSubSectionDef = window.gSession.App.BookDef[mstrBookSeqNo].Section[objSectionIndexs.SectionIndex].SubSection[objSectionIndexs.SubSectionIndex]
        }
        console.log("objSubSectionDef: ", objSubSectionDef)

        switch (parseInt(LUCatSeqNo))
        {
            case window.gDCPLUEnum.LessonGoals:
                objBlock = <LessonGoals PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} />
                break
            case window.gDCPLUEnum.LessonAnimation:
                objBlock = <LessonAnimation PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} />
                break
            case window.gDCPLUEnum.LessonIllustration:
                objBlock = <LessonIllustration PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            case window.gDCPLUEnum.LessonLessonText:
                objBlock = <LessonLessonText PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} />
                break
            case window.gDCPLUEnum.LanguageNotesVocabulary:
                objBlock = <LanguageNotesVocabulary PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            case window.gDCPLUEnum.LanguageNotesLanguagePoints:
                objBlock = <LanguageNotesLanguagePoints PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            case window.gDCPLUEnum.LanguageNotesLanguageTips:
                objBlock = <LanguageNotesLanguageTips PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            case window.gDCPLUEnum.CulturePointsDiscoveringChina:
                objBlock = <CulturePointsDiscoveringChina PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            case window.gDCPLUEnum.CulturePointsChineseIdiom:
                objBlock = <CulturePointsChineseIdiom PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            case window.gDCPLUEnum.PracticePinyinPronunciation:
                objBlock = <PracticePinyinPronunciation PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} />
                break
            case window.gDCPLUEnum.PracticePinyinIdentification:
                // objBlock = <PracticePinyinIdentification PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} AssignmentHistory={marrNewAssignmentHistory}/>
                objBlock = <PracticePinyinIdentification PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            case window.gDCPLUEnum.PracticePinyinDictation:
                objBlock = <PracticePinyinDictation PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} />
                break
            case window.gDCPLUEnum.PracticeCharacters:
                objBlock = <PracticeCharacters PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} />
                break
            case window.gDCPLUEnum.PracticeListening:
                objBlock = <PracticeListening LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} />
                break
            case window.gDCPLUEnum.PracticeFluency:
                objBlock = <PracticeFluency PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} />
                break
            case window.gDCPLUEnum.PracticeSpeaking:
                objBlock = <PracticeSpeaking PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            case window.gDCPLUEnum.PracticeReadingComprehension:
                objBlock = <PracticeReadingComprehension LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} />
                break
            case window.gDCPLUEnum.PracticeReadingChallenge:
                objBlock = <PracticeReadingChallenge PathName={props.location.pathname} LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            case window.gDCPLUEnum.PracticeWritingGrammarExercises:
                objBlock = <PracticeWritingGrammarExercises LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} />
                break
            case window.gDCPLUEnum.PracticeWritingComposition:
                objBlock = <PracticeWritingComposition LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            case window.gDCPLUEnum.PracticeActivity:
                objBlock = <PracticeActivity LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            case window.gDCPLUEnum.ReviewListening:
                objBlock = <ReviewListening LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} />
                break
            case window.gDCPLUEnum.ReviewReading:
                objBlock = <ReviewReading LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} />
                break
            case window.gDCPLUEnum.ReviewWritingGrammarExercises:
                objBlock = <ReviewWritingGrammarExercises LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} />
                break
            case window.gDCPLUEnum.ReviewWritingComposition:
                objBlock = <ReviewWritingComposition LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            case window.gDCPLUEnum.ReviewSpeaking:
                objBlock = <ReviewSpeaking LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            case window.gDCPLUEnum.CanDoStatements:
                objBlock = <CanDoStatements LUInfo={objLUInfo} LessonID={strLessonID} CallbackRef={ComponentCallback} SubSectionDef={objSubSectionDef} GoToLUSinceAction={mintGoToLUSinceAction} />
                break
            default:
                objBlock = null
                break;
        }

        let objBlockLUArea = null
        if (window.gSession.App.InApp)
        {
            objBlockLUArea = (
                <div className={cssLearningUnit.divLUArea}
                    onTouchStart={(event) => LUContentAreaOnTouchStart(event)}
                    onTouchMove={(event) => LUContentAreaOnTouchMove(event)}
                    onTouchEnd={(event) => LUContentAreaOnTouchEnd(event)}>
                    {objBlock}
                </div>
            )
        }
        else
        {
            objBlockLUArea = (<div className={cssLearningUnit.divLUArea}>
                {objBlock}
            </div>)
        }

        return (
            <>
                {objBlockLUArea}
            </>
        )

    }

    /*===========================================
    summary: Render LessonList Content的顯示
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function RenderLessonListContentWrapper()
    {
        return (
            <div className={cssLearningUnit.divLessonListContent}>
                {marrLessonTitle.map((LessonTitleData, LessonIndex) =>
                    <div key={LessonIndex} className={GetLessonUnitCls(LessonTitleData.Expired)}
                        onClick={(evnet) => LessonItemOnTapHandler(evnet, LessonTitleData.LessonID, LessonTitleData.Expired)}>
                        <div className={cssLearningUnit.divLessonIcon} />

                        <div className={cssLearningUnit.divLessonTitleMain}>
                            <div className={cssLearningUnit.divLessonTitleCN}>
                                {LessonTitleData.TitleCN}
                            </div>
                            <div className={GetLessonTitleENCls(window.gSession.App.InApp)}>
                                {LessonTitleData.TitleEN}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    } // end of RenderLessonListContentWrapper

    /*===========================================
    summary: Render 下方 Tool選單 的顯示
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function RenderBottomToolMenuWrapper(StateToolMenuAnimation, StateLUCatSeqNo)
    {
        return (
            <Slide direction="up" in={StateToolMenuAnimation}
                timeout={250} mountOnEnter unmountOnExit>
                <div className={cssLearningUnit.divBottomTool}>
                    <ToolBarBottomUnit ButtonType={window.gButtonTypeEnum.LearningUnit}
                        History={props.history}
                        LessonID={window.gSession.App.CurrentLesson.ID}
                        LUCatSeqNo={StateLUCatSeqNo}
                        CallbackRef={ComponentCallback} />
                </div>
            </Slide>
        )
    } // end of RenderBottomToolMenuWrapper

    /*===========================================
    summary: Render 左邊 Tool選單 的顯示
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function RenderLeftToolMenuWrapper(StateLessonListAnimation)
    {
        return (
            <Slide direction="right" in={StateLessonListAnimation}
                timeout={250} mountOnEnter unmountOnExit>
                {RenderLessonListContentWrapper()}
            </Slide>
        )
    } // end of RenderLeftToolMenuWrapper

    /*===========================================
    summary: Render 上方 Tool選單 的顯示
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function RenderTopToolMenuWrapper(StateToolMenuAnimation, StateLUCatSeqNo)
    {
        // set Title of Top Toolbar
        let strTitleCN = ""

        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = window.gSession.App.BookDef[mstrBookSeqNo].Lesson[mintLessonIndex].MajorPrefixName + ": " + window.gSession.App.BookDef[mstrBookSeqNo].Lesson[mintLessonIndex].MajorName;
        }
        else
        {
            strTitleCN = window.gSession.App.BookDef[mstrBookSeqNo].Lesson[mintLessonIndex].MinorPrefixName + ": " + window.gSession.App.BookDef[mstrBookSeqNo].Lesson[mintLessonIndex].MinorName;
        }

        let objLUInfo = window.gSession.App.CurrentLesson.Def.LearningUnit.find(LU => LU.LUCatSeqNo === StateLUCatSeqNo)

        return (
            <Slide direction="down" in={StateToolMenuAnimation}
                timeout={250} mountOnEnter unmountOnExit>
                <div className={cssLearningUnit.divTopTool}>
                    <ToolBarTopUnit Title={strTitleCN}
                        ButtonType={window.gButtonTypeEnum.LearningUnit}
                        LearningUnitDef={objLUInfo}
                        CallbackRef={ComponentCallback} />
                </div>
            </Slide>
        )
    } // end of RenderTopToolMenuWrapper

    /*===========================================
    summary: Render Tool選單 的顯示
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function RenderToolMenuWrapper(StateToolMenu)
    {
        // console.log(COMP_NAME + ".RenderToolMenuWrapper Lesson: ", window.gSession.App.BookDef[mstrBookSeqNo].Lesson)

        if (StateToolMenu)
        {
            return (
                <div className={cssLearningUnit.divMask} onClick={() => MaskOnTapHandler()}>

                    {RenderTopToolMenuWrapper(toolMenuAnimation, lUSeqNo)}

                    {RenderLeftToolMenuWrapper(lessonListAnimation)}

                    {RenderBottomToolMenuWrapper(toolMenuAnimation, lUSeqNo)}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderToolMenuWrapper

    function RenderSectionMenuWraper()
    {
        console.log(COMP_NAME + ".RenderSectionMenuWraper: ")
        console.log("mobjCurrentSectionIndexs", mobjCurrentSectionIndexs)

        return (
            <>
                {RenderSectionMenu(mobjCurrentSectionIndexs.SectionIndex)}
                {RenderSubSectionMenu(mobjCurrentSectionIndexs.SectionIndex, mobjCurrentSectionIndexs.SubSectionIndex)}

                <div className={cssLearningUnit.btnTool} onClick={() => ToolOnTapHandler()} />
            </>
        )
    }

    function RenderSectionMenu(SectionIndex)
    {
        console.log(COMP_NAME + ".RenderSectionMenu: ", SectionIndex)

        return (
            <div className={cssLearningUnit.divSectionMenu}>
                {window.gSession.App.BookDef[mstrBookSeqNo].Section.map((Result, Index) =>
                    <div key={Index} className={GetSectionCls(SectionIndex, Index, Result)} onClick={() => SectionOnTapHandler(Index)}>
                        {Result.Name}
                    </div>
                )}
            </div>
        )
    }

    function ContentonSwipe(Direction)
    {
        console.log(COMP_NAME + ".ContentonSwipe", Direction)

        if (Direction === window.gSwipeDirectionEnum.Left)
        {
            ProcessNext()
        }
        else if (Direction === window.gSwipeDirectionEnum.Right)
        {
            ProcessPrevious()
        }
    }

    function MouseUpInContent(EventMode, e)
    {
        console.log(COMP_NAME + ".MouseUpInContent", EventMode, e)

        if (!mblnTouchBegan)
        {
            return;
        }

        console.log("MouseUpInContent: e.target: ", e.target);
        console.log("MouseUpInContent: e.target.tagName: ", e.target.tagName);
        // console.log("e.target.getAttribute('type'): ", e.target.getAttribute('type'));

        let intOffsetX;
        let intOffsetY;

        let intDeltaX;
        let intDeltaY;

        let blnIsSwipeEvent = false;

        let enumSwipeDirection = window.gSwipeDirectionEnum.Right;

        if (EventMode === window.gEventModeEnum.Touch)
        {
            // e.preventDefault();
            intOffsetX = e.changedTouches[0].pageX;
            intOffsetY = e.changedTouches[0].pageY;
        }
        else
        {
            // mouse
            intOffsetX = e.offsetX; // React Web 無值
            intOffsetY = e.offsetY; // React Web 無值

            // intOffsetX = e.nativeEvent.offsetX;  // React Web 看到有值
            // intOffsetY = e.nativeEvent.offsetY;  // React Web 看到有值
        }
        console.log("MouseUpInContent: intOffsetX: ", intOffsetX);
        console.log("MouseUpInContent: intOffsetY: ", intOffsetY);

        // now we only support left and right
        intDeltaX = intOffsetX - mintTouchStartX;
        intDeltaY = intOffsetY - mintTouchStartY;

        if (intDeltaX < 0)
        {
            enumSwipeDirection = window.gSwipeDirectionEnum.Left;
            intDeltaX = Math.abs(intDeltaX);
        }
        if (intDeltaY < 0)
        {
            intDeltaY = Math.abs(intDeltaY);
        }

        if (((intDeltaX * intDeltaX) + (intDeltaY * intDeltaY)) > (window.gConst.SWIPE_DIST_THRESHOLD * window.gConst.SWIPE_DIST_THRESHOLD))
        {
            // 距離夠了

            if ((new Date().getTime() - mdatTouchStartTime.getTime()) <= window.gConst.SWIPE_MS_THRESHOLD)
            {
                // 時間夠短

                if ((intDeltaY / intDeltaX) < (1 / 1.732))
                {
                    // 角度夠小
                    blnIsSwipeEvent = true;
                }
            }
        }

        console.log("MouseUpInContent: blnIsSwipeEvent: ", blnIsSwipeEvent);

        if (blnIsSwipeEvent)
        {
            console.log("MouseUpInContent: blnIsSwipeEvent:", blnIsSwipeEvent);
            let blnIsInputRange = (e.target.tagName.toLowerCase() === "input") && (e.target.getAttribute('type').toLowerCase() === "range"); // React 無type
            console.log("MouseUpInContent: blnIsInputRange:", blnIsInputRange);

            if (!blnIsInputRange)
            {
                console.log("MouseUpInContent: ContentonSwipe");
                ContentonSwipe(enumSwipeDirection);
            }
        }

        mblnTouchBegan = false;
    }

    function MouseDownInContent(EventMode, e)
    {
        console.log(COMP_NAME + ".MouseDownInContent", EventMode, e)

        // console.log("MouseDownInContent e.nativeEvent.which:", e.nativeEvent.which)

        // 判斷 滑鼠左鍵 才有作用
        if (
            (EventMode === window.gEventModeEnum.Mouse) &&
            (e.which !== 1)    // 1: Left, 2: Middle, 3: Right  // React Web 無值 e.which: undefined 在 e.nativeEvent.which 才有值
        )
        {
            return;
        }

        console.log("MouseDownInContent: Left")
        let intOffsetX;
        let intOffsetY;

        if (mblnIsSwipeDisable || !window.gSession.App.InApp) // DCP LearningUnit 的 Web版 不使用Swipe
        {
            return;
        }

        console.log("MouseDownInContent: MouseDownInContent: Left 2")

        if (EventMode === window.gEventModeEnum.Touch)
        {
            // 會阻擋 輸入框 選擇 先拿掉       Tim16.08.18
            // e.preventDefault();
            intOffsetX = e.changedTouches[0].pageX;
            intOffsetY = e.changedTouches[0].pageY;
        }
        else
        {
            // mouse
            // intOffsetX = e.offsetX; // React Web 無值
            // intOffsetY = e.offsetY; // React Web 無值

            intOffsetX = e.nativeEvent.offsetX;  // React Web 看到有值
            intOffsetY = e.nativeEvent.offsetY;  // React Web 看到有值
        }

        console.log("MouseDownInContent: intOffsetX:", intOffsetX)
        console.log("MouseDownInContent: intOffsetY:", intOffsetY)

        mintTouchStartX = intOffsetX;
        mintTouchStartY = intOffsetY;
        mdatTouchStartTime = new Date();
        mblnTouchBegan = true;

        console.log("MouseDownInContent: mintTouchStartX:", mintTouchStartX)
        console.log("MouseDownInContent: mintTouchStartY:", mintTouchStartY)
        console.log("MouseDownInContent: mdatTouchStartTime:", mdatTouchStartTime)
        console.log("MouseDownInContent: mblnTouchBegan:", mblnTouchBegan)
    }

    function MouseMoveInContent(EventMode, e)
    {
        // console.log(COMP_NAME + ".MouseMoveInContent", EventMode, e)

        if (EventMode === window.gEventModeEnum.Touch)
        {
            // e.preventDefault();
        }
    }

    function LUContentAreaOnTouchStart(e)
    {
        console.log(COMP_NAME + ".LUContentAreaOnTouchStart", e)
        if (mblnChangePageByTouchEvent)
        {
            MouseDownInContent(window.gEventModeEnum.Touch, e);
        }
    }

    function LUContentAreaOnTouchMove(e)
    {
        console.log(COMP_NAME + ".LUContentAreaOnTouchMove", e)
        if (mblnChangePageByTouchEvent)
        {
            MouseMoveInContent(window.gEventModeEnum.Touch, e);
        }
    }

    function LUContentAreaOnTouchEnd(e)
    {
        console.log(COMP_NAME + ".LUContentAreaOnTouchEnd", e)

        if (mblnChangePageByTouchEvent)
        {
            console.log("mblnChangePageByTouchEvent Enable")
            // Select text on App
            // Ref: https://stackoverflow.com/questions/50846404/how-do-i-get-the-selected-text-from-a-wkwebview-from-objective-c
            let txt = document.getSelection().toString()
            console.log("LUContentAreaOnMouseUp: txt:", txt)
            MouseUpInContent(window.gEventModeEnum.Touch, e)
        }
        // mblnChangePageByTouchEvent = true // Reset // 因為LU裡面的TouchEnd先觸發 所以不從LU的TouchEnd 設定  mblnChangePageByTouchEvent = true 到 LearningUnit的TouchEnd才設定
    }

    function RenderSubSectionMenu(SectionIndex, SubSectionIndex)
    {
        console.log(COMP_NAME + ".RenderSubSectionMenu: ", SectionIndex, SubSectionIndex)

        return (
            <div className={cssLearningUnit.divSubSectionMenu}>
                {window.gSession.App.BookDef[mstrBookSeqNo].Section[SectionIndex].SubSection.map((Result, Index) =>
                    <div key={Index} className={GetSubSectionCls(SubSectionIndex, Index, Result)} onClick={() => SubSectionOnTapHandler(Index)}>
                        {Result.MenuName}
                    </div>
                )}
            </div>
        )
    }

    function RenderPageButtonArea()
    {
        console.log(COMP_NAME + ".RenderPageButtonArea: ")
        return (
            <>
                <div className={GetPreviousCls()} onClick={() => PreviousOnTapHandler()}></div>
                <div className={GetNextCls()} onClick={() => NextOnTapHandler()}></div>
            </>
        )
    }

    function RenderPageArea()
    {
        console.log(COMP_NAME + ".RenderPageArea: ")

        let objBlock = null
        if (window.gSession.App.InApp)
        {
            console.log("RenderPageArea for App")
            // App 使用 onTouchStart, onTouchMove, onTouchEnd 判斷 Swipe等觸控事件
            objBlock = null
        }
        else
        {
            console.log("RenderPageArea for Web")
            // Web中 使用 onMouseMove, onMouseDown, onMouseUp 及 onMouseOut 判斷 Swipe等觸控事件
            objBlock = (
                <>
                    {RenderPageButtonArea()}
                </>
            )
        }
        return objBlock
    }

    function RenderHistoryWindow(StateShowHistoryWindow)
    {
        console.log(COMP_NAME + ".RenderHistoryWindow: ", StateShowHistoryWindow)

        let objBlockHistoryWindow = null
        if (StateShowHistoryWindow)
        {
            objBlockHistoryWindow = <HistoryWindow
                LessonID={mobjCallerInfoForHistoryWindow.LessonID}
                LUCatSeqNo={lUSeqNo}
                AssigementHistoryList={mobjCallerInfoForHistoryWindow.AssigementHistoryList}
                AssignmentTempAns={mobjCallerInfoForHistoryWindow.AssignmentTempAns}
                CallbackRef={ComponentCallback}
            />
        }
        return objBlockHistoryWindow
    }

    function RenderImageEditorWindow(StateShowImageEditorWindow)
    {
        console.log(COMP_NAME + ".RenderImageEditorWindow: ", StateShowImageEditorWindow)
        let objBlockImageEditorWindow = null
        if (StateShowImageEditorWindow)
        {
            objBlockImageEditorWindow = <ImageEditorWindow
                Arguments={mobjCallerInfoForImageEditorWindow.Arguments}
                CallbackRef={ComponentCallback} />
        }
        return objBlockImageEditorWindow
    }

    function RenderStrokeWindow(StateShowStrokeWindow)
    {
        console.log(COMP_NAME + ".RenderStrokeWindow: ", StateShowStrokeWindow)
        let objBlockStrokeWindow = null
        if (StateShowStrokeWindow)
        {
            objBlockStrokeWindow = <StrokeWindow
                Arguments={mobjCallerInfoForStrokeWindow.Arguments}
                CallbackRef={ComponentCallback}
                CallbackToLURef={mobjCallerInfoForStrokeWindow.CallbackRef}
            />
        }
        return objBlockStrokeWindow
    }

    function RenderAudioRecorderWindow(StateShowAudioRecorderWindow)
    {
        console.log(COMP_NAME + ".RenderAudioRecorderWindow: ", StateShowAudioRecorderWindow)
        let objBlockAudioRecorderWindow = null
        if (StateShowAudioRecorderWindow)
        {
            objBlockAudioRecorderWindow = <AudioRecordingWindow
                // Arguments={mobjCallerInfoForAudioRecorderWindow.Arguments}
                CallbackRef={ComponentCallback}
                CallbackToLURef={mobjCallerInfoForAudioRecorderWindow.CallbackRef}
            />
        }
        return objBlockAudioRecorderWindow
    }

    function RenderImageDisplayWindow(StateShowImageDisplayWindow)
    {
        console.log(COMP_NAME + ".RenderImageDisplayWindow: ", StateShowImageDisplayWindow)
        let objBlockImageDisplayWindow = null
        if (StateShowImageDisplayWindow)
        {
            objBlockImageDisplayWindow = <ImageDisplayWindow
                Arguments={mobjCallerInfoForImageDisplayWindow.Arguments}
                CallbackRef={ComponentCallback}
            />
        }
        return objBlockImageDisplayWindow
    }

    function RenderViderPlayerWindowWrapper(StateShowViderPlayerWindow)
    {
        if (StateShowViderPlayerWindow)
        {
            return (
                <ViderPlayerWindow Arguments={mobjCallerInfoForVideoPlayerWindow.Arguments}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    }

    /*===========================================
    summary: Render Learning Unit Tool Tip 的顯示
    remarks: 000 Tim 2022/01/12 Create
    ===========================================*/
    function RenderLearningUnitToolTipWrapper(StateShowLearningUnitToolTip)
    {
        if (StateShowLearningUnitToolTip)
        {
            return (
                <LearningUnitToolTip CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderLearningUnitToolTipWrapper

    // remarks: 001 Tim 2023/09/07 開啟DCPAssessmentUrl App
    //                             不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
    // function RenderDownloadAnotherAppWindowWrapper()
    // {
    //     let objBlock = null
    //     if (showDownloadAnotherAppWindow)
    //     {
    //         objBlock = <DownloadAnotherAppWindow CallbackRef={DownloadAnotherAppWindowCallback} />
    //     }
    //     return objBlock
    // }

    return (

        <div className={cssLearningUnit.divMain}>
            {RenderSectionMenuWraper()}
            <LUCacheContext.Provider value={mobjLUCacheContext}>
                {RenderLUContent(lUSeqNo)}
            </LUCacheContext.Provider>
            {RenderPageArea()}

            {RenderToolMenuWrapper(toolMenu)}

            {RenderOpenWebWindowWrapper(isShowOpenWebWindow)}
            {RenderBCAppsWindowsWrapper(isShowBCAppsWindows)}

            {RenderSettingsWrapper(isShowSettings)}
            {RenderGlossaryWrapper(isShowGlossary)}
            {RenderNoteListWrapper(isShowNoteList)}
            {RenderResourceWrapper(isShowResource)}

            {RenderLUAssignWrapper(isShowLUAssign)}
            {RenderNoteEditWrapper(isShowNoteEdit)}

            {RenderHistoryWindow(showHistoryWindow)}
            {RenderImageEditorWindow(showImageEditorWindow)}
            {RenderAudioRecorderWindow(showAudioRecorderWindow)}
            {RenderImageDisplayWindow(showImageDisplayWindow)}
            {RenderStrokeWindow(showStrokeWindow)}

            {RenderViderPlayerWindowWrapper(showViderPlayerWindow)}

            {RenderLearningUnitToolTipWrapper(isShowLearningUnitToolTip)}
            {/* {RenderDownloadAnotherAppWindowWrapper()} */}


            <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
            <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
            <CredentialMultiInWindow ShowCredentialMultiIn={showCredentialMultiIn} 
                        CredentialMultiInArguments={credentialMultiInArguments}/>
        </div>
    )
    // #endregion Render
}

export default LearningUnit
// export default withRouter(LearningUnit)